import React, { useEffect, useRef, useState } from 'react';
import * as d3 from "d3";
import { Button, ButtonGroup, Col, Dropdown, Form, InputGroup, Overlay, Row, Tooltip, Image } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard'; //copy text to clipboard
import FeatherIcon from 'feather-icons-react';

import { v4 as uuidv4 } from 'uuid'; //unique id
// import { roundOffDecimal, measureConverter } from '../../../../../_services/common.service';
import i18n from "../../../../../_translations/i18n"; 
// import { checkSimulateSnapAllow } from '../../../AddMethods';
import { elmAccordingtoXY, GetContainingProdsByBox, groupBy, getSnappingLocation } from '../mpsimCommenMethods';
import { convertUomtoSym, measureConverter, numOfDecimalsLimit, roundOffDecimal, stringtrim } from '../../../../../_services/common.service';
import { CodeSquareIcon, DiffAddedIcon, ListUnorderedIcon, SearchIcon, XIcon } from '@primer/octicons-react';

import { notSimulatedReason, catRuleEnums, catRectEnums } from '../../../../../enums/masterPlanogramEnums';
import { ReplaceProdIconArrow, FilterIconNew } from '../../../../../assets/icons/icons';
import { alertService } from '../../../../../_services/alert.service';
import Select from 'react-select';
import { PopoverWrapper, TooltipWrapper } from '../../../AddMethods';
import SalesCycleIcon from '../../../../../assets/img/icons/sale_cycle.png';
import ThreeDQtyIcon from '../../../../../assets/img/icons/3d_qty.png';
import SaleQtyIcon from '../../../../../assets/img/icons/sale_qty.png';
import DayCountIcon from '../../../../../assets/img/icons/day_count.png';
import MiniThreeDQtyIcon from '../../../../../assets/img/icons/mini_3d_qty.png';
import MiniSaleQtyIcon from '../../../../../assets/img/icons/mini_sale_qty.png';
import MiniDayCountIcon from '../../../../../assets/img/icons/mini_day_count.png';
import WarnIcon from '../../../../../assets/img/icons/warn_full.png';
import DefaultProdImg from '../../../../../assets/img/icons/default_W100_100.jpg';

  export class BlockRectangle extends React.Component {
    constructor(props){
        super(props);

        this._guideTimeout = null;
        this._dragStartXY = {x: 0, y: 0};

        this.state = {
            selectBlockObj: null, bkpBlockObj: null,
            droppingShelveIdx: -1, droppingShelveObj: null,
            isviewcmenu: false, contxtmenu: {xpos:0, ypos: 0, xidx: 0, scatidx: 0},
            spaceValidation: {isAllowToDrop: false, totalProductWidth: 0, totalShelfWidth: 0, restSpace: 0, movingProductBlockWidth: 0, selectedInlineShelfSet: []},
            // PEG CR - 2025 March
        }
    }
  
    componentDidMount() {
      let isInsidePeg = false;
      let droppedPegBoard = null;
      let insideHalfPegBoard = false;

      //#PDU-SM07 - d3 init
      const handleDrag = d3.drag()
        .subject(() => {
          const me = d3.select(this["LM01"]);
          return { x: me.attr('x'), y: me.attr('y') }
        })
        .on('start', (event) => {
          // console.log("START")
          this._dragStartXY = { x: event.x, y: event.y };
          this.props.dragStart(event, this.props.curitem.prod.productInfo, true);
        })
        .on('drag', (event) => {
          const me = d3.select(this["LM01"]);
          me.attr('x', event.x);
          me.attr('y', event.y);

          //scroll parent div with d3 drag
          let parent = document.getElementById(this.props.wrapperId);
          let zoomXRatio = this.props.zoomXRatio;

          let w = parent.offsetWidth; 
          let h = parent.offsetHeight;
          let sL = parent.scrollLeft;
          let sT = parent.scrollTop;

          // For peg board detection, use SVG viewBox coordinates (event.x/y are already in SVG coords)
          let movewidth = this.state.selectBlockObj?.drawWidth || 0;
          let moveheight = this.state.selectBlockObj?.drawHeight || 0;

          // For peg board boundary check - use original SVG coordinates
          let x = event.x;
          let x2 = event.x + movewidth;
          let y = event.y;
          let y2 = event.y + moveheight;

          // For scroll calculation - need screen/zoomed coordinates
          let scrollX = (event.x * (zoomXRatio > 0?(zoomXRatio + 1):1));
          let scrollX2 = scrollX + (movewidth * (zoomXRatio > 0?(zoomXRatio + 1):1));
          let scrollY = (event.y * (zoomXRatio > 0?(zoomXRatio + 1):1));
          let scrollY2 = scrollY + (moveheight * (zoomXRatio > 0?(zoomXRatio + 1):1));
          // PEG CR - 2025 March
          // check is it inside the peg boards
          if(this.props.pegList){
            for (let i = 0; i < this.props.pegList.length; i++) {
              const {pegDrawingRect} = this.props.pegList[i];

              // let pegBoardStartX = pegDrawingRect.pegRectStartx;
              // let pegBoardStartY = pegDrawingRect.y;

              // let pegBoardEndX = pegDrawingRect.pegRectEndx;
              // let pegBoardEndY = pegDrawingRect.y + pegDrawingRect.height;

              let pegBoardStartX = pegDrawingRect.drawX;
              let pegBoardStartY = pegDrawingRect.drawY;

              let pegBoardEndX = pegDrawingRect.drawX + pegDrawingRect.drawRectWidth;
              let pegBoardEndY = pegDrawingRect.drawY + pegDrawingRect.drawRectHeight;

              // Check if the product is fully inside the peg board
              if(pegBoardStartX < x && pegBoardEndX > x2 && pegBoardStartY < y && pegBoardEndY > y2){
                isInsidePeg = true;
                insideHalfPegBoard = false;
                droppedPegBoard = this.props.pegList[i];
                // console.log("INSIDE PEG BOARD!")
                break;
                // clear the preview guid
                // this.props.setPreviewGuid(true);
              }
              // Check if at least 3% of the product's width or height is inside the peg board
              else if (
                (x < pegBoardEndX && x2 > pegBoardStartX) && // Horizontally overlapping
                (y < pegBoardEndY && y2 > pegBoardStartY) // Vertically overlapping
              ) {
                let productWidth = movewidth;
                let productHeight = moveheight;

                let overlapWidth = Math.min(x2, pegBoardEndX) - Math.max(x, pegBoardStartX);
                let overlapHeight = Math.min(y2, pegBoardEndY) - Math.max(y, pegBoardStartY);

                // Calculate percentage of product width and height overlapping with peg board
                let widthOverlapPercent = (overlapWidth / productWidth) * 100;
                let heightOverlapPercent = (overlapHeight / productHeight) * 100;

                // If at least 3% of the width or height is inside the peg board, set insideHalfPegBoard to true
                if (widthOverlapPercent >= 3 || heightOverlapPercent >= 3) {
                  isInsidePeg = false; 
                  insideHalfPegBoard = true; // Set true if at least 3% of product is inside
                  break;
                  // console.log("HALF INSIDE PEG BOARD!")
                }
              }else{
                isInsidePeg = false;
                droppedPegBoard = null;
                insideHalfPegBoard = false;
              }
            }
          }

          //if dragging horizontal - use zoomed coordinates for scroll
          if (scrollX2 > w + sL) {
            parent.scrollLeft = (scrollX2 - w);
          } else if (scrollX < sL) {
            parent.scrollLeft = (scrollX);
          }

          //if dragging vertical - use zoomed coordinates for scroll
          if (scrollY2 > h + sT) {
            parent.scrollTop = (scrollY2 - h);
          } else if (scrollY < sT) {
            parent.scrollTop = (scrollY);
          }
          if(!isInsidePeg || !insideHalfPegBoard){
            this.onDragGuidline(event,event.x,event.y);
          }
        })
        .on('end', (event) => {
          // this.updateSaveObj(event,event.x,event.y);
          if(insideHalfPegBoard){
            alertService.error(i18n.t("PRODUCT_HALF_INSIDE_THE_PEGBOARD"),4000);
            this.setState({selectBlockObj:null})
            this.props.resetSelectBlockObjData();
            return;
          }
          if(isInsidePeg){
            this.handleProductsDropInsidePegBoard(event, event.x, event.y, droppedPegBoard)
          }else{
            //this.updateSaveObjV2(event,event.x,event.y , this.props.actualFieldStructuresNew); // OLD CODE CHANGE
            this.updateSaveObjV2(event,event.x,event.y , this.props.mapFields); // NEW CODE CHANGE 2025 - OCT
          }
        });

        this.props.groupByProduct();

        let selectedObj = this.props.currentSelectedBlock;
        let isDel = false;
        selectedObj?.drawingProducts?.forEach((item) => {
          if (item.isProductDelete) {
            isDel = true;
          }
        })

        if (!isDel) {
          handleDrag(d3.select(this["LM01"]));
        }
      
      //#PDU-SM08
      var handleResizeXLeft = d3.drag()
        .subject(() => {
          const me = d3.select(this["rsx_left"]);
          return { x: me.attr('x'), y: me.attr('y') }
        })
        .on('drag', (event) => {
          let isallowresize = this.checkAllowMoveResize(event, false);
          if(isallowresize.isallow){
            const me = d3.select(this["rsx_left"]);
            me.attr('x', event.x);
          }
        })
        .on('end', (event) => {
          this.checkAllowMoveResize(event, false, true);
        });
      handleResizeXLeft(d3.select(this["rsx_left"]));
  
      var handleResizeXRight = d3.drag()
        .subject(() => {
          const me = d3.select(this["rsx_right"]);
          return { x: me.attr('x'), y: me.attr('y') }
        })
        .on('drag', (event) => {
          let isallowresize = this.checkAllowMoveResize(event, true);
          if(isallowresize.isallow){
            const me = d3.select(this["rsx_right"]);
            me.attr('x', event.x);
          }
        })
        .on('end', (event) => {
          this.checkAllowMoveResize(event, true, true);
        });
      handleResizeXRight(d3.select(this["rsx_right"]));
  
      //#PDU-SM09 - calc new product block
      let prodinfo = this.props.curitem.prod;
      let blockobj = this.props.currentSelectedBlock;
      //recalc
      if(blockobj){
        var firsttime=true
        let startx = 0; let starty = 0; 
        let endx = 0, endy = 0;
        let maximx = 0;
        let sortlowYprods = blockobj.drawingProducts.sort((a,b) => a.y - b.y);
        starty = sortlowYprods[0].y
        for (let i = 0; i < blockobj.drawingProducts.length; i++) {
          const locitem = blockobj.drawingProducts[i];
          
          if(!locitem.isDelete){
            //set lowest x
            if(firsttime){
              startx = locitem.x;
            }else{
              if( startx > locitem.x){
                startx = locitem.x;
              }
            }
            //set lowest y
            // if(starty === 0 || starty > locitem.y){
            //   starty = locitem.y;
            // }
            //set highest x
            if(endx === 0 || endx < (locitem.x + locitem.drawWidth)){
              endx = (locitem.x + locitem.drawWidth);
            }
            //set highest y
            if(endy === 0 || endy < (locitem.y + locitem.drawHeight)){
              endy = (locitem.y + locitem.drawHeight);
            }
  
            if(locitem.x > maximx){
              maximx = locitem.x;
            }
          }
          firsttime=false
        }
        
        let drawwidth = (endx - startx);
        let drawheight = (endy - starty);
        let blocktotalwidth = (drawwidth / this.props.displayratio);
        let blocktotalheight = (drawheight / this.props.displayratio);
        
        blockobj.x = startx;
        blockobj.OrigX = startx
        blockobj.y = starty;
        blockobj.width = blocktotalwidth;
        blockobj.height = blocktotalheight;
        blockobj.uom = prodinfo.uom;
        blockobj.drawWidth = drawwidth;
        blockobj.drawHeight = drawheight;
        blockobj.newDrawingProducts = JSON.parse(JSON.stringify(blockobj.drawingProducts));
        var movingObj=this.setmovingObj( blockobj.newDrawingProducts);
        blockobj.selectedshelves=movingObj
        this.setState({ selectBlockObj: blockobj, bkpBlockObj: JSON.parse(JSON.stringify(blockobj)) },()=>{});
      }
  
    }

    componentDidUpdate(){
      if(this.props.removeGhost){
        this.setState({selectBlockObj:null})
        this.props.resetSelectBlockObj();
      }
    }
    
    componentWillUnmount(){
      if(this._guideTimeout){
        clearTimeout(this._guideTimeout);
      }
    }

    setmovingObj=(drawingprods)=>{
      var groupobj=groupBy(drawingprods,"shelfrank")
      var slevtedShelves=[]
      if(Object.keys(groupobj).length>0){
        for (var key of Object.keys(groupobj)) {
          var ele=groupobj[key]
          var heightsetProd=0
          for (let i = 0; i < ele.length; i++) {
            const prod = ele[i];
            if(heightsetProd<prod.drawHeight){
              heightsetProd=prod.drawHeight
            }
          }

          let sortlowxprods = ele.sort((a,b) => a.x - b.x);
          let lowprodx = roundOffDecimal(sortlowxprods[0].x,2);
          let highprodx = roundOffDecimal((sortlowxprods[(sortlowxprods.length - 1)].x + sortlowxprods[(sortlowxprods.length - 1)].drawWidth),2);

          var obj = {
            rank: ele[0].shelfrank,
            heighestdrawingProduct: heightsetProd,
            selectedProducts: ele,
            lowProdX: lowprodx,
            highProdX: highprodx,
          }
          slevtedShelves.push(obj)
        }
      }
      return slevtedShelves
    }
    
    //#PDU-SM10 - check if allow to resize or move rect
    checkAllowMoveResize = (event, isoppside, isend, isychange) => {
      
      let oriblockobj = this.state.bkpBlockObj;
      const blockobj = this.state.selectBlockObj;
  
      //if resize/move allowed
      let isallowchange = {isallow: false};
  
      if(!isoppside){
        if(event.x > oriblockobj.x && event.x < ((oriblockobj.x + oriblockobj.drawWidth) - 10)){
          isallowchange.isallow = true;
        }
      } else{
        if(event.x < (oriblockobj.x + oriblockobj.drawWidth) && event.x > (oriblockobj.x + 10)){
          isallowchange.isallow = true;
        }
      }
      
      if(isend && isallowchange.isallow){
        //adjust x
        for (let i = 0; i < oriblockobj.drawingProducts.length; i++) {
          const prodlocation = oriblockobj.drawingProducts[i];
          
          if(isychange){
            
            if(prodlocation.y <= event.y && (prodlocation.y + prodlocation.drawHeight) >= event.y){
              if(!isoppside){
                let ygap = (prodlocation.y - blockobj.y);
                blockobj.drawHeight = (blockobj.drawHeight - ygap);
                blockobj.height = (blockobj.drawHeight / this.props.displayratio);
  
                blockobj.y = prodlocation.y;
              } else{
                blockobj.drawHeight = ((prodlocation.y + prodlocation.drawHeight) - oriblockobj.y);
                blockobj.height = (blockobj.drawHeight / this.props.displayratio);
              }
            }
          } else{
            if(prodlocation.x <= event.x && (prodlocation.x + prodlocation.drawWidth) >= event.x){
              if(!isoppside){
                //left
                let xgap = (prodlocation.x - blockobj.x);
                blockobj.drawWidth = (blockobj.drawWidth - xgap);
                blockobj.width = (blockobj.drawWidth / this.props.displayratio);
  
                blockobj.x = prodlocation.x;
              } else{
                blockobj.drawWidth = ((prodlocation.x + prodlocation.drawWidth) - this.state.selectBlockObj.x);
                blockobj.width = (blockobj.drawWidth / this.props.displayratio);
              }
            }
          }
        }
        //filter inside blockobj product locations
        blockobj.newDrawingProducts = oriblockobj.drawingProducts.filter( xitem => 
          xitem.x >= blockobj.x && (xitem.x + xitem.drawWidth) <= (blockobj.x + blockobj.drawWidth) &&
          xitem.y >= blockobj.y && (xitem.y + xitem.drawHeight) <= (blockobj.y + blockobj.drawHeight)
        );
        
        if(!isoppside){
          if(isychange){
            const me = d3.select(this["rsy_top"]);
            me.attr('y', blockobj.y);
          } else{
            const me = d3.select(this["rsx_left"]);
            me.attr('x', blockobj.x);
          }
          
        } else{
          if(isychange){
            const me = d3.select(this["rsy_bottom"]);
            me.attr('y', (blockobj.y + blockobj.drawHeight));
          } else{
            const me = d3.select(this["rsx_right"]);
            me.attr('x', (blockobj.x + blockobj.drawWidth));
          }
        }
  
        this.setState({ selectBlockObj: blockobj });
      }
  
      //console.log(isallowchange);
      return isallowchange;
    }
    checkAllowinsideField=()=>{

    }
    //find which shelve product moving and validate is it can add to shelve
    onDragGuidline = (evt,cx,cy) => {
      
      if(this._guideTimeout){ 
        clearTimeout(this._guideTimeout); 
        if(this.props.isFirstTimeDrawguid){
          this.props.setPreviewGuid(false, null, null, true, []);
        }
      }

      this._guideTimeout = setTimeout(() => {
        this.Setguidline(evt,cx,cy);
      }, 50);
    }

    // set space validation
    setSpaceValidation = (isAllowToDrop, totalProductWidth, totalShelfWidth, restSpace, movingProductBlockWidth, selectedInlineShelfSet) => {
      this.setState({ spaceValidation: { isAllowToDrop, totalProductWidth, totalShelfWidth, restSpace, movingProductBlockWidth, selectedInlineShelfSet } });
    }

    Setguidline=(evt,cx,cy)=>{
      var props={
        evt:evt,
        cx:cx,
        cy:cy,
        selectBlockObj:this.state.selectBlockObj,
        mapFields:this.props.mapFields,
        mapCatRects:this.props.mapCatRects,
        mapproductList:this.props.mapproductList,
        setPreviewGuid:this.props.setPreviewGuid,
        updateGhostObjDetails:this.props.updateGhostObjDetails,
        setSpaceValidation: this.setSpaceValidation,
        actualFieldStructuresNew:this.props.actualFieldStructuresNew
      }
      setGuidlineComman(props)
    }

    
    //#PDU-SM11 - update new block changes and save main object
    updateSaveObj = (evt,cx,cy) => {
      let checkSaftyMargin = 3;
      let dragStartXY = this._dragStartXY;

      if(dragStartXY.x !== cx || dragStartXY.y !== cy){
        let historydata = null;
        let movingObj = structuredClone(this.state.selectBlockObj);
        let dropallow = true;

        var MOStartX = roundOffDecimal(cx,2);
        var MOStartY = roundOffDecimal(cy,2);
        var MOEndX = roundOffDecimal((cx + movingObj.drawWidth),2);
        var MOEndY = roundOffDecimal((cy + movingObj.drawHeight),2);
  
        var containElem = elmAccordingtoXY(cx,cy,movingObj.drawWidth,movingObj.drawHeight,this.props.mapFields,this.props.mapCatRects)

        var selectingField = containElem.field;
        
        if(containElem.isInsideShelf&& selectingField){
          var fieldStartX = roundOffDecimal(selectingField.x,2);
          var fieldStartY = roundOffDecimal(selectingField.y,2);
          var fieldEndX = roundOffDecimal((selectingField.x+selectingField.drawWidth),2);
          var fieldEndY = roundOffDecimal((selectingField.x+selectingField.drawHeight),2);
         
          let isinsidefield = false;
          //check moving box is inside field
          if((fieldStartX < MOStartX && fieldEndX > MOEndX) && (fieldStartY < MOStartY && fieldEndY > MOEndY)){
            isinsidefield = true;
          } else{
            if(fieldStartY < MOStartY && fieldEndY > MOEndY){
              //if item x1 is less than field x1 and item x2 not greater than field x2
              
              if(fieldStartX > MOStartX && fieldEndX > MOEndX){
                MOStartX = fieldStartX;
                isinsidefield = true;
              }
              //if item x1 is greater than field x1 and item x2 not less than field x2
              if(fieldStartX < MOStartX && fieldEndX < MOEndX){
                MOStartX = roundOffDecimal((fieldEndX - movingObj.drawWidth),2);
                isinsidefield = true;
              }
            }

            //if block inside field but not from bottom of field
            if((fieldStartX < MOStartX && fieldEndX > MOEndX) && fieldStartY < MOStartY){
              MOStartY = roundOffDecimal((fieldEndY - selectingField.drawHeight),2);
              MOEndY = roundOffDecimal(fieldEndY,2);
              isinsidefield = true;
            }
          }
          
          //if is it inside field
          if(isinsidefield){
            historydata=JSON.parse(JSON.stringify(this.props.mapproductList))

            var existingProducts = JSON.parse(JSON.stringify(this.props.mapproductList));
            let changefield = this.props.mapFields[selectingField.key];
            //console.log("loc2");
            var containProds = GetContainingProdsByBox(MOStartX , MOStartY, MOEndX, MOEndY, existingProducts, changefield, false, null, [], true);

            // console.log("loc12",MOStartX , MOStartY, MOEndX, MOEndY, existingProducts, changefield);
            let lowestprodx = MOStartX;
            let cutshelfs = []; 
            let droppingXProd = null; //to find prod available in dropping x1 position
            let isDropPosBetweenEnd = false;
            let isRightSideDropXProd = false;

            if(containProds.selectedProds&&containProds.selectedProds.length>0){
              var notDeletedContainProds = containProds.selectedProds.filter(f => !f.isDelete);
  
              for (let p = 0; p < notDeletedContainProds.length; p++) {
                const prod = notDeletedContainProds[p];
                // movingObj.selectedshelves.forEach(ele => {
                  for (let j = 0; j < movingObj.selectedshelves.length; j++) {
                    const ele = movingObj.selectedshelves[j];
                    var ishaveinSlectedshleves=ele.selectedProducts.find(x=>x.id===prod.id)
                      //check save moving produtcs not cutting
                      if(ishaveinSlectedshleves === undefined){
                        let prodstartx = (prod.x);
                        
                        let checkprodwidth = (((prod.drawWidth / 3) > 8)?(prod.drawWidth / 3):(prod.drawWidth / 2));
                        let prodmiddlex = (prod.x + checkprodwidth);
                        
                        if(lowestprodx > prodstartx && lowestprodx < prodmiddlex){
                          lowestprodx = prod.x;
                        }
                        
                        //left side
                        let prodendx = roundOffDecimal((prod.x + prod.drawWidth),2);
                        if((prod.x <= MOStartX && MOStartX <= prodendx)){
                          droppingXProd = prod;

                          let lowSaftyStartX = (MOStartX - checkSaftyMargin);
                          let highSaftyStartX = (MOStartX + checkSaftyMargin);

                          if(lowSaftyStartX <= prodendx && highSaftyStartX >= prodendx){
                            isDropPosBetweenEnd = true;
                          }
                        }

                        //right side
                        if(!droppingXProd && (prod.x <= MOEndX && MOEndX <= (prod.x + prod.drawWidth))){
                          droppingXProd = prod;
                          isRightSideDropXProd = true;

                          let lowSaftyEndX = (MOEndX - checkSaftyMargin);
                          let highSaftyEndX = (MOEndX + checkSaftyMargin);

                          if(lowSaftyEndX <= prodstartx && highSaftyEndX >= prodstartx){
                            isDropPosBetweenEnd = true;
                          }
                        }
                      }
                  }
                  
                // });
               
              }
            }
  
            let containshelfs = (selectingField.contain_shelfs?selectingField.contain_shelfs:[]);
            
            //if dropping position x not have product find last left product x to drop
            // commented get snapping location - (automatically magnetizes a product to another product)
            let isRightFieldUpdated = false;
            // if(!droppingXProd){
            //   lowestprodx = getSnappingLocation(lowestprodx, selectingField, existingProducts, movingObj, containshelfs);
            // }

            lowestprodx = (
              droppingXProd && isDropPosBetweenEnd && isRightSideDropXProd?(droppingXProd.x - movingObj.drawWidth):
              droppingXProd && isDropPosBetweenEnd?(droppingXProd.x + droppingXProd.drawWidth):
            lowestprodx);

            //if end x is more than field end x
            let checkheighstx = (lowestprodx + movingObj.drawWidth);
            //left side
            if(lowestprodx <= selectingField.x){
              lowestprodx = selectingField.x;
            }

            //right side
            if(checkheighstx >= (selectingField.x+selectingField.drawWidth)){
              lowestprodx = ((selectingField.x+selectingField.drawWidth) - movingObj.drawWidth);
            }

            var maxEndX = 0; var maxY = 0; var maxEndY = 0;
            for (let m = 0; m < movingObj.selectedshelves.length; m++) {
              const changeshelf = movingObj.selectedshelves[m];
              
              //if found
              if(containshelfs[m]){
                //check shelf is lager than highest product in shelve line
                if((containshelfs[m].drawHeight<changeshelf.heighestdrawingProduct
                  // ||containshelfs[m].drawHeight===changeshelf.heighestdrawingProduct
                  )
                  ){
                  dropallow = false
                  //dont drop 
                  break
                }
                let curshelfitemy = (containshelfs[m]?(containshelfs[m].y + containshelfs[m].drawHeight):0);
                //dragfromcat
                this.props.TouchedCatListUpdate(changeshelf.selectedProducts[0].categoryRectId)
                for (let k = 0; k < changeshelf.selectedProducts.length; k++) {
                  const changeproditem = changeshelf.selectedProducts[k];
                  
                  let gapbetweenoribox = (changeproditem.x - movingObj.x);

                  changeproditem["x"] = (lowestprodx + gapbetweenoribox);
                  changeproditem["y"] = (curshelfitemy - changeproditem.drawHeight);
                  changeproditem["shelfrank"] = containshelfs[m].rank;
                  changeproditem["field_custom_id"] = containshelfs[m].field_custom_id;
                  changeproditem["categoryRectId"] = containElem.catrect.catrectId;
                  
                  existingProducts[changeproditem.prodidx] = changeproditem;
                  existingProducts[changeproditem.prodidx]["isDelete"] = false;
                  
                  if(maxY<changeproditem.y){
                    maxY=changeproditem.y
                    maxEndY=changeproditem.y+changeproditem.drawHeight;
                  }
  
                  let curprodendx = (changeproditem.x + changeproditem.drawWidth);
                  if(curprodendx > maxEndX){
                    maxEndX = curprodendx
                  }
                } 
               
              }
              
            }
            
            var newMOEndY = roundOffDecimal(maxEndY - this.props.checkSaftyMargin,2);
            // var saftyMargintoStart=1
            
            //console.log("loc3"); +saftyMargintoStart)
            var ccontainProds = GetContainingProdsByBox(lowestprodx, MOStartY, maxEndX, newMOEndY, this.props.mapproductList, changefield, true, movingObj, containshelfs);
            // console.log(ccontainProds);

            // console.log("loc14",(lowestprodx+saftyMargintoStart), MOStartY, maxEndX, newMOEndY, this.props.mapproductList, changefield, true, movingObj, containshelfs);
            if(dropallow){
              if(historydata!==null){
                this.props.fieldHistoryAdd(historydata,1);
              }
              let isruleupdating = false;
              //removingcutting prod
              if(ccontainProds.selectedProds&&ccontainProds.selectedProds.length>0){
                var cnotDeletedContainProds = ccontainProds.selectedProds.filter(f => !f.isDelete);
                
                for (let p = 0; p < cnotDeletedContainProds.length; p++) {
                  const prod = cnotDeletedContainProds[p];
                  // console.log(prod.x);
                  prod["startingPointDraw"]=prod.x
                  prod["startingPoint"]=prod.x/this.props.displayratio
                  prod.isNew= true
                  prod.isDelete= false
                  let isincontainshelfs = containshelfs.findIndex(l => l.rank === prod.shelfrank);
  
                  if(isincontainshelfs > -1){
                    var ishaveinSelectedshleves = movingObj.newDrawingProducts.find(x => x.id === prod.id);
                    //check save moving produtcs not cutting
                    if(ishaveinSelectedshleves === undefined){
                      let findshelfitemidx = cutshelfs.findIndex(x => x.shelfrank === prod.shelfrank);
  
                      if(findshelfitemidx > -1){
                        cutshelfs[findshelfitemidx].products.push(prod);
                      } else{
                        cutshelfs.push({ shelfrank: prod.shelfrank, products: [prod] });
                      }
                      
                      existingProducts[prod.prodidx]["isDelete"] = true;
                      
                      if(existingProducts[prod.prodidx].subcategory && existingProducts[prod.prodidx].subcategory.type === catRectEnums.rule){
                          isruleupdating = true;
                      }
                    } 
                  }
                }
              }
  
              const arrayHashmap = cutshelfs.reduce((obj, item) => {
                obj[item.shelfrank] ? obj[item.shelfrank].products.push(...item.products) : (obj[item.shelfrank] = { ...item });
                return obj;
              }, {});
              
              const mergedArray = Object.values(arrayHashmap);
              var selcutlist={
                groupUUID: uuidv4(),isNew:true, isDelete: false, mode:"cut" ,uom:containshelfs[0].uom,shelf:mergedArray
              }
              //drop to cat update touchedcat list
              this.props.TouchedCatListUpdate(containElem.catrect.catrectId)
  
              this.props.updateProductList(existingProducts, isruleupdating);
              this.props.updateCutList(selcutlist);
              // console.log(cutshelfs);
              this.setState({selectBlockObj:null})
            }else{
              alertService.error(i18n.t("SOME_PRoD_HEIGHT_EXCEED_SELECTED_SHELF_HEIGHT"),4000);
              this.resetToOriginalState()
              clearTimeout(this._guideTimeout); 
            }
            
  
          }else{
            this.resetToOriginalState()
          }
        }else{
          this.resetToOriginalState()
        }
        
        this.props.setPreviewGuid(true,null,selectingField)
      }
    }


    // Version 2 changes in here
    updateSaveObjV2 = (evt,cx,cy,actualFieldStructuresNew) => {
      const {isAllowToDrop, movingProductBlockWidth, totalProductWidth} = this.state.spaceValidation;
      
      if(!isAllowToDrop){
        // when product block double click prevent show below error msg.
        if (movingProductBlockWidth !== 0 && movingProductBlockWidth !== null && movingProductBlockWidth !== undefined) {
          alertService.error(i18n.t('NO_SPACE_AVALIBLE_FOR_DROPPED_PRODUCT_SET'), 4000);
        }
       //this.resetToOriginalState() // NEW CHANGE IN 2025 - OCT
        this.props.setPreviewGuid(true, null, null, true, []);
        clearTimeout(this._guideTimeout); 
        this.setState({
          spaceValidation: {isAllowToDrop: false, totalProductWidth: 0, totalShelfWidth: 0, restSpace: 0, movingProductBlockWidth: 0, selectedInlineShelfSet: []}
        })
        return
      }
      let checkSaftyMargin = 3;
      let dragStartXY = this._dragStartXY;

      if(dragStartXY.x !== cx || dragStartXY.y !== cy){
        let historydata = null;
        let movingObj = structuredClone(this.state.selectBlockObj);
        let dropallow = true;

        var MOStartX = roundOffDecimal(cx,2);
        var MOStartY = roundOffDecimal(cy,2);
        var MOEndX = roundOffDecimal((cx + movingObj.drawWidth),2);
        var MOEndY = roundOffDecimal((cy + movingObj.drawHeight),2);
  
        var containElem = elmAccordingtoXY(cx,cy,movingObj.drawWidth,movingObj.drawHeight,this.props.mapFields,this.props.mapCatRects)

        var selectingField = containElem.field;
        
        if(!selectingField?.masterFieldId) return

        // OLD DEVELOPMENT CODE
        // const matchingField = Object.keys(actualFieldStructuresNew).find(
        //   field => field.masterFieldId === selectingField.masterFieldId
        // );

        // NEW DEVELOPMENT CODE 2025 - OCT
        const matchingFieldKey = Object.keys(actualFieldStructuresNew).find(
          (key) => actualFieldStructuresNew[key].masterFieldId === selectingField.masterFieldId
        );

        const matchingField = actualFieldStructuresNew[matchingFieldKey].masterFieldId;
        
        if(containElem.isInsideShelf&& selectingField){
          var fieldStartX = roundOffDecimal(selectingField.x,2);
          var fieldStartY = roundOffDecimal(selectingField.y,2);
          // var fieldEndX = roundOffDecimal((selectingField.x+selectingField.drawWidth),2);
          var fieldEndX = roundOffDecimal((selectingField.x+selectingField.drawWidth+matchingField?.drawWidth),2);
          var fieldEndY = roundOffDecimal((selectingField.x+selectingField.drawHeight),2);
         
          let isinsidefield = false;
          //check moving box is inside field
          if((fieldStartX < MOStartX && fieldEndX > MOEndX) && (fieldStartY < MOStartY && fieldEndY > MOEndY)){
            isinsidefield = true;
          } else{
            if(fieldStartY < MOStartY && fieldEndY > MOEndY){
              //if item x1 is less than field x1 and item x2 not greater than field x2
              
              if(fieldStartX > MOStartX && fieldEndX > MOEndX){
                MOStartX = fieldStartX;
                isinsidefield = true;
              }
              //if item x1 is greater than field x1 and item x2 not less than field x2
              if(fieldStartX < MOStartX && fieldEndX < MOEndX){
                //MOStartX = roundOffDecimal((fieldEndX - movingObj.drawWidth),2);
                isinsidefield = true;
              }
            }

            //if block inside field but not from bottom of field
            if((fieldStartX < MOStartX && fieldEndX > MOEndX) && fieldStartY < MOStartY){
              // MOStartY = roundOffDecimal((fieldEndY - selectingField.drawHeight),2);
              // MOEndY = roundOffDecimal(fieldEndY,2);
              isinsidefield = true;
            }
          }

          //if is it inside field
          if(isinsidefield){
            historydata=JSON.parse(JSON.stringify(this.props.mapproductList))

            var existingProducts = JSON.parse(JSON.stringify(this.props.mapproductList));
            let changefield = this.props.mapFields[selectingField.key];
            //console.log("loc2");
            var containProds = GetContainingProdsByBox(MOStartX , MOStartY, MOEndX, MOEndY, existingProducts, changefield, false, null, [], true);

            // console.log("loc12",MOStartX , MOStartY, MOEndX, MOEndY, existingProducts, changefield);
            let lowestprodx = MOStartX;
            let cutshelfs = []; 
            let droppingXProd = null; //to find prod available in dropping x1 position
            let isDropPosBetweenEnd = false;
            let isRightSideDropXProd = false;

            if(containProds.selectedProds&&containProds.selectedProds.length>0){
              var notDeletedContainProds = containProds.selectedProds.filter(f => !f.isDelete);
  
              for (let p = 0; p < notDeletedContainProds.length; p++) {
                const prod = notDeletedContainProds[p];
                // movingObj.selectedshelves.forEach(ele => {
                  for (let j = 0; j < movingObj.selectedshelves.length; j++) {
                    const ele = movingObj.selectedshelves[j];
                    var ishaveinSlectedshleves=ele.selectedProducts.find(x=>x.id===prod.id)
                      //check save moving produtcs not cutting
                      if(ishaveinSlectedshleves === undefined){
                        let prodstartx = (prod.x);
                        
                        let checkprodwidth = (((prod.drawWidth / 3) > 8)?(prod.drawWidth / 3):(prod.drawWidth / 2));
                        let prodmiddlex = (prod.x + checkprodwidth);
                        
                        if(lowestprodx > prodstartx && lowestprodx < prodmiddlex){
                          lowestprodx = prod.x;
                        }
                        
                        //left side
                        let prodendx = roundOffDecimal((prod.x + prod.drawWidth),2);
                        if((prod.x <= MOStartX && MOStartX <= prodendx)){
                          droppingXProd = prod;

                          let lowSaftyStartX = (MOStartX - checkSaftyMargin);
                          let highSaftyStartX = (MOStartX + checkSaftyMargin);

                          if(lowSaftyStartX <= prodendx && highSaftyStartX >= prodendx){
                            isDropPosBetweenEnd = true;
                          }
                        }

                        //right side
                        if(!droppingXProd && (prod.x <= MOEndX && MOEndX <= (prod.x + prod.drawWidth))){
                          droppingXProd = prod;
                          isRightSideDropXProd = true;

                          let lowSaftyEndX = (MOEndX - checkSaftyMargin);
                          let highSaftyEndX = (MOEndX + checkSaftyMargin);

                          if(lowSaftyEndX <= prodstartx && highSaftyEndX >= prodstartx){
                            isDropPosBetweenEnd = true;
                          }
                        }
                      }
                  }
                  
                // });
               
              }
            }
  
            let containshelfs = (selectingField.contain_shelfs?selectingField.contain_shelfs:[]);
            
            lowestprodx = (
              droppingXProd && isDropPosBetweenEnd && isRightSideDropXProd?(droppingXProd.x - movingObj.drawWidth):
              droppingXProd && isDropPosBetweenEnd?(droppingXProd.x + droppingXProd.drawWidth):
            lowestprodx);

            // if end x is more than field end x
            let checkheighstx = (lowestprodx + movingObj.drawWidth);
            //left side
            if(lowestprodx <= selectingField.x){
              lowestprodx = selectingField.x;
            }

            // right side
            if(checkheighstx >= (selectingField.x+selectingField.drawWidth+matchingField.drawWidth)){
              // lowestprodx = ((selectingField.x+selectingField.drawWidth+matchingField.drawwidth) - movingObj.drawWidth);
            }

            var maxEndX = 0; var maxY = 0; var maxEndY = 0;
            let droppedFiledCustomId = null;
            let droppedFieldMasterFieldId =null;
            for (let m = 0; m < movingObj.selectedshelves.length; m++) {
              const changeshelf = movingObj.selectedshelves[m];
              
              //if found
              if(containshelfs[m]){
                //check shelf is lager than highest product in shelve line
                if((containshelfs[m].drawHeight<changeshelf.heighestdrawingProduct
                  // ||containshelfs[m].drawHeight===changeshelf.heighestdrawingProduct
                  )
                  ){
                  dropallow = false
                  //dont drop 
                  break
                }
                let curshelfitemy = (containshelfs[m]?(containshelfs[m].y + containshelfs[m].drawHeight):0);
                //dragfromcat
                this.props.TouchedCatListUpdate(changeshelf.selectedProducts[0].categoryRectId)
                for (let k = 0; k < changeshelf.selectedProducts.length; k++) {
                  const changeproditem = changeshelf.selectedProducts[k];
                  
                  let gapbetweenoribox = (changeproditem.x - movingObj.x);

                  changeproditem["x"] = (lowestprodx + gapbetweenoribox);
                  changeproditem["y"] = (curshelfitemy - changeproditem.drawHeight);
                  changeproditem["shelfrank"] = containshelfs[m].rank;
                  changeproditem["field_custom_id"] = containshelfs[m].field_custom_id;
                  changeproditem["masterFieldId"] = selectingField?.masterFieldId;
                  // 2025 OCT NEW CHANGE
                  changeproditem["productPlaceShelfHeight"] = containshelfs[m].height; // update shelf height in product when product moved
                  changeproditem["mark_height_issue"] = containshelfs[m].height < changeproditem.height ? true : false; // mark height issue if shelf height less than product height
                  // changeproditem["isHanged"] = false;
                  // NEW CR
                  // this one use to product re arrange
                  droppedFiledCustomId = containshelfs[m].field_custom_id;
                  droppedFieldMasterFieldId = changefield.masterFieldId;
                  changeproditem["categoryRectId"] = containElem?.catrect?.catrectId;
                  
                  existingProducts[changeproditem.prodidx] = changeproditem;
                  existingProducts[changeproditem.prodidx]["isDelete"] = false;
                  
                  if(maxY<changeproditem.y){
                    maxY=changeproditem.y
                    maxEndY=changeproditem.y+changeproditem.drawHeight;
                  }
  
                  let curprodendx = (changeproditem.x + changeproditem.drawWidth);
                  if(curprodendx > maxEndX){
                    maxEndX = curprodendx
                  }
                } 
               
              }
              
            }
            
            var newMOEndY = roundOffDecimal(maxEndY - this.props.checkSaftyMargin,2);

            var ccontainProds = GetContainingProdsByBox(lowestprodx, MOStartY, maxEndX, newMOEndY, this.props.mapproductList, changefield, true, movingObj, containshelfs);
         
            if(dropallow){
              if(historydata!==null){
                this.props.fieldHistoryAdd(historydata,1);
              }
              let isruleupdating = false;
              //removingcutting prod
              if(ccontainProds.selectedProds&&ccontainProds.selectedProds.length>0){
                var cnotDeletedContainProds = ccontainProds.selectedProds.filter(f => !f.isDelete);
                
                for (let p = 0; p < cnotDeletedContainProds.length; p++) {
                  const prod = cnotDeletedContainProds[p];
                  // console.log(prod.x);
                  prod["startingPointDraw"]=prod.x
                  prod["startingPoint"]=prod.x/this.props.displayratio
                  prod.isNew= true
                  prod.isDelete= false
                  let isincontainshelfs = containshelfs.findIndex(l => l.rank === prod.shelfrank);

                  if(isincontainshelfs > -1){
                    const actualFieldStructures = this.props.actualFieldStructures
                    const result = actualFieldStructures.find(item => 
                      item?.mpField?.field_shelves.some(shelf => shelf?.shelf_id === containshelfs[isincontainshelfs]?.id)
                    );

                    const shelf = result?.mpField?.field_shelves.find(shelf => shelf?.shelf_id === containshelfs[isincontainshelfs]?.id);

                    const getDrawWidth = (measureConverter(shelf?.uom ,"cm",shelf?.width)*this.props.displayratio);
                    
                    //draw blockobj for containProds after that move shelf left side   
                    var ishaveinSelectedshleves = movingObj.newDrawingProducts.find(x => x.id === prod.id);
                    //check save moving produtcs not cutting
                    if(ishaveinSelectedshleves === undefined){
                      let findshelfitemidx = cutshelfs.findIndex(x => x.shelfrank === prod.shelfrank);
  
                      if(findshelfitemidx > -1){
                        cutshelfs[findshelfitemidx].products.push(prod);
                      } else{
                        cutshelfs.push({ shelfrank: prod.shelfrank, products: [prod] });
                      }
                      
                    }
                    
                  }
                }
              }
            
              // New CR Updating 
              const {selectedInlineShelfSet} = this.state.spaceValidation
              let movingProductSet = structuredClone(this.state.selectBlockObj)?.drawingProducts;

              // Verify and correct product positions before re-arranging
              movingProductSet = this.verifyAndCorrectProductPositions(movingProductSet);

              // re arrange the group product locations
              let reArrangeProducts = JSON.parse(JSON.stringify(this.props.mapproductList));
              let movingProductObj = structuredClone(this.state.selectBlockObj);
              const {needToReArrange, updatedProducts} = this.filterInlineShelfProductSet(cx, cy, selectedInlineShelfSet, reArrangeProducts, movingProductSet, movingProductObj, checkSaftyMargin, droppedFiledCustomId, droppedFieldMasterFieldId);


              if(needToReArrange){
                const updatingProductIds = new Set(updatedProducts.map(product => product.id));
   
                const filteredUpdatedProducts = existingProducts.filter(
                    product => !updatingProductIds.has(product.id)
                ); 
   
                existingProducts = [...filteredUpdatedProducts, ...updatedProducts];
              }
 
              // PEG CR - 2025 March
              // check if any product cross the peg board
              const {isPegBoardOverlap} = this.productOverlapCheckerWithPegBoard(this.props.pegList, existingProducts)
              
              if(isPegBoardOverlap){
                alertService.error(i18n.t('PEG_BOARD_OVERLAP'),4000);
                this.setState({selectBlockObj:null})
                this.props.setPreviewGuid(true,null,selectingField)
                return;
              }

              // Assume isHanged = true product coming from the peg board to shelf
              // When product coming from peg board to shelf, need to check movingProductSet have the same product
              // If yes, then set isHanged = false in existingProducts 
              const updatedProductsWithHanged = existingProducts.map(product => {
                const isHangedProduct = movingProductSet.find(movingProduct => (movingProduct.id === product.id && movingProduct.isHanged));
                if (isHangedProduct) {
                  return {
                    ...product,
                    isHanged: false,
                    id: uuidv4(),
                    isNew: true,
                    isDelete: false,
                  };
                }
                return product;
              });

              this.props.updateProductList(updatedProductsWithHanged, isruleupdating);
              // this.props.updateProductList(updatedProducts, isruleupdating);

              // this.props.updateCutList(selcutlist);
              this.setState({selectBlockObj:null})

              this.props.groupByProduct();
            }else{
              alertService.error(i18n.t("SOME_PRoD_HEIGHT_EXCEED_SELECTED_SHELF_HEIGHT"),4000);
              this.resetToOriginalState()
              clearTimeout(this._guideTimeout); 
            }
            
  
          }else{
            this.resetToOriginalState()
          }
        }else{
          this.resetToOriginalState()
        }
        
        this.props.setPreviewGuid(true,null,selectingField)
      }
    }

    // filter product set which is in selected inline shelf
    filterInlineShelfProductSet(cx, cy, inlineShelfSet, productSet, movingProductSet , movingObj, checkSaftyMargin, droppedFiledCustomId, droppedFieldMasterFieldId){

      let  sortedInlineShelfSet = inlineShelfSet.sort((a, b) => a.x - b.x);
      let  movingProducts = movingProductSet;
      let  changingShelfRank = sortedInlineShelfSet[0]?.rank;
      let  changingShelfHeight = sortedInlineShelfSet[0]?.y + sortedInlineShelfSet[0]?.drawHeight;

      // Create a Set of product IDs from movingProductSet for quick lookup
      const movingProductIds = new Set(movingProductSet.map(product => product.id));

      // Filter productSet based on the conditions
      let existingProductSet =  productSet.filter(product => {
            const matchingShelf = sortedInlineShelfSet.find(
                shelf => shelf.rank === product.shelfrank && shelf.field_custom_id === product.field_custom_id
            );
            // Include only products that match the shelf and are not in movingProductSet
            return matchingShelf && !movingProductIds.has(product.id) && !product.isDelete && !product.isHanged;
      });

      var MOStartX = roundOffDecimal(cx,2);
      var MOEndX = roundOffDecimal((cx + movingObj.drawWidth),2);

      // shelf x position add shelfs full width
      let firstShelfXPosition = sortedInlineShelfSet[0]?.x;
      let shelfFullWidth = 0;
      for (let shelfs of sortedInlineShelfSet) {
        shelfFullWidth += shelfs.drawWidth;
      }
      // add full width to first shelf x coordinat
      let shelfFullWidthShelfX = roundOffDecimal((shelfFullWidth + firstShelfXPosition),2);

      // Check if any product crosses MOStartX to MOEndX
      let needToReArrange = existingProductSet
      .filter(product => !product.isDelete)
      .filter(product => !product.isHanged) // Exclude hanged products
      .some(product => {
        const productStart = product.x;
        const productEnd = product.x + product.drawWidth;
        // Check if the product overlaps with the MOStartX to MOEndX area
        // return productStart-checkSaftyMargin < MOEndX && productEnd+checkSaftyMargin > MOStartX;
        return (productStart < MOEndX && productEnd > MOStartX) || (MOEndX > shelfFullWidthShelfX+checkSaftyMargin);
      });

      // handle if existing product not avaliable and user try to put product outside of the field
      if(existingProductSet.length === 0){
        if(MOEndX > shelfFullWidthShelfX+checkSaftyMargin){
          needToReArrange = true;
        }
      }

      if(needToReArrange){
          // ---------------------------------------------------------------------
          // ---------------------------------------------------------------------
          // AUTO ALIGN WITH MINUMUM PRODUCT MOVEMENT ----------------------------
          // New Version - 2025 Jan 29 -------------------------------------------
          // ---------------------------------------------------------------------

          // Group products by groupId
          const groupedProducts = existingProductSet
              .filter(product => !movingProductIds.has(product.id)) // Remove movingObj products
              .filter(product => !product.isDelete) // Remove products with isDelete = true
              .reduce((acc, product) => {
                  if (!acc[product.groupId]) {
                      acc[product.groupId] = [];
                  }
                  acc[product.groupId].push(product);
                  return acc;
              }, {});

          // Separate products into left and right side sets based on group logic
          let leftSideProductSet = [];
          let rightSideProductSet = [];

          Object.values(groupedProducts).forEach(group => {
              // Check the position of the first product in the group
              if (group.some(product => product.x < MOStartX)) {
                  // If any product in the group goes to the left side, all go to the left side
                  leftSideProductSet.push(...group);
              // } else if (group.some(product => product.x >= MOEndX)) {
              } else if (group.some(product => product.x >= MOStartX)) {
                  // If any product in the group goes to the right side, all go to the right side
                  rightSideProductSet.push(...group);
              }
          });

          let sortedLeftSideProductSet = leftSideProductSet.sort((a, b) => a.x - b.x);
          let sortedRightSideProductSet = rightSideProductSet.sort((a, b) => a.x - b.x);

          // console.log("START sortedLeftSideProductSet - ", sortedLeftSideProductSet)
          // console.log("START movingObj - ", movingObj)
          // console.log("START movingProducts - ", movingProducts)
          // console.log("START sortedRightSideProductSet - ", sortedRightSideProductSet)
          
          let newChangedSpaceAmount = 0;
          let currentX = 0;
          let howMuchSpaceWant = movingObj.drawWidth;
          let getSpacingDirection = 'BOTH';

          // console.log("SPACE 0 -", newChangedSpaceAmount)
          // console.log("WANT 0 -", howMuchSpaceWant)
          // console.log("X 0 -", currentX)

          let shelfStartX = sortedInlineShelfSet[0]?.x;
          let shelfEndX = sortedInlineShelfSet[sortedInlineShelfSet.length - 1]?.x + sortedInlineShelfSet[sortedInlineShelfSet.length - 1]?.drawWidth;
          let shelfTotalWidth = sortedInlineShelfSet.reduce((sum, obj) => sum + obj.drawWidth, 0);

          // this function return the direction and both side avaliable space
          let spacingAmount = this.getDirectionToOptimizedTheGetProductSpacing(cx, movingObj.drawWidth, shelfStartX, shelfTotalWidth, sortedLeftSideProductSet, sortedRightSideProductSet);
          // console.log("SPACING -", spacingAmount)

          if(spacingAmount?.direction === "LEFT"){
            let leftSideLastProductX = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
            // validation for not over the shelf width
            if(leftSideLastProductX + movingObj.drawWidth <  shelfStartX + shelfTotalWidth ){
              let diff = leftSideLastProductX - cx;
              if(spacingAmount?.leftSpace > diff){
                getSpacingDirection = 'LEFT';
                howMuchSpaceWant =  diff;
              }
              // comment out for prevent inverse side spacing optimazation
              // else if(spacingAmount?.rightSpace > diff){
              //   getSpacingDirection = 'RIGHT';
              //   howMuchSpaceWant =  diff;
              // } 
            }
          }
          if(spacingAmount?.direction === "RIGHT"){
            let movingProductEndX = cx + movingObj.drawWidth;
            let righSideFirstProductX = sortedRightSideProductSet[0].x;
            let diff = movingProductEndX - righSideFirstProductX;

            if(spacingAmount?.rightSpace > diff){
              getSpacingDirection = 'RIGHT';
              howMuchSpaceWant =  diff;
            }
            // comment out for prevent inverse side spacing optimazation
            // else if(spacingAmount?.leftSpace > diff){
            //   getSpacingDirection = 'LEFT';
            //   howMuchSpaceWant =  diff;
            // }
          }

          // console.log("DIRECTION 1 -", getSpacingDirection)
          // console.log("WANT 000000000000 -", howMuchSpaceWant)

          // Handle Both side spacing 
          if(getSpacingDirection === "BOTH"){
              // console.log("SPACE 1 -", newChangedSpaceAmount)
              // console.log("WANT 1 -", howMuchSpaceWant)
              // console.log("X 1 -", currentX)
              let needToAdjustLeftProducts = [];
              if (roundOffDecimal(newChangedSpaceAmount,2) < roundOffDecimal(howMuchSpaceWant,2) && sortedLeftSideProductSet?.length > 0) {
                  for (let i = sortedLeftSideProductSet.length - 1; i >= 0; i--) {
                    let adjustableSpace = 0;
                    const currentProduct = sortedLeftSideProductSet[i];
                    const previousProduct = sortedLeftSideProductSet[i - 1] || null;

                    if(previousProduct){
                      if(i === sortedLeftSideProductSet.length - 1 && sortedRightSideProductSet.length > 0){
                        let righSideProdX = sortedRightSideProductSet[0].x;
                        let avalibleSpace = (righSideProdX - movingObj.drawWidth) - currentProduct.x;
                        let rightSideAllProductsWidth = 0;
                        let leftSideLastProdXandWidth = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
                        if(sortedRightSideProductSet.length > 0){
                          rightSideAllProductsWidth = sortedRightSideProductSet.reduce((sum, obj) => sum + obj.drawWidth, 0);
                        }
                        if(avalibleSpace + movingObj.drawWidth > howMuchSpaceWant && leftSideLastProdXandWidth + movingObj.drawWidth + rightSideAllProductsWidth <= shelfEndX){
                          break;
                        }else{
                          adjustableSpace = currentProduct.x - (previousProduct.x + previousProduct.drawWidth);
                        }
                      }else{
                        adjustableSpace = currentProduct.x - (previousProduct.x + previousProduct.drawWidth);
                      }
                        // let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                        // handle the space optimization before the assign shelf start x
                        // if(adjustableSpace > howMuchSpaceWant && cx + movingObj.drawWidth < shelfXWithWidth){
                        // handle long space avalible in the left side last product with the moving product
                        // let righSideStartX = sortedRightSideProductSet[0].x;
                        
                        if(newChangedSpaceAmount + adjustableSpace > howMuchSpaceWant){
                          adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount;
                        }
                    }else{
                        // align to shelf x coordnate
                        let shelfX = this.getShelfXPosition(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                        // let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                        if(shelfX <= currentProduct.x){
                          adjustableSpace = currentProduct.x - shelfX;
                          // adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount; 
                          // handle the space optimization before the assign shelf start x
                          // if(adjustableSpace > howMuchSpaceWant && roundOffDecimal(cx + movingObj.drawWidth,2) < roundOffDecimal(shelfXWithWidth,2)){
                          if(adjustableSpace > howMuchSpaceWant){
                            adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount; 
                          }
                        }
                    }

                    // push to updating array
                    needToAdjustLeftProducts.push({product: currentProduct, reduceSpace: adjustableSpace });
                    newChangedSpaceAmount += adjustableSpace;

                    if(newChangedSpaceAmount >= howMuchSpaceWant) break;
                  }

                  // console.log("LEFT ADJUST PRDO - ",needToAdjustLeftProducts)
                  // update the new x values
                  for (let i = 0; i < needToAdjustLeftProducts.length; i++) {
                    const product = needToAdjustLeftProducts[i].product;
            
                    // need to assign total x value to get correct coordinate
                    const sumValue = needToAdjustLeftProducts
                      .slice(i) // Take the current and subsequent objects
                      .reduce((sum, item) => sum + item.reduceSpace, 0);

                    product.x = product.x - sumValue;
                    product.startingPoint = product.x / this.props.displayratio;
                  }

                  // update update product set to sortedLeftSideProductSet
                  const productObjects = needToAdjustLeftProducts.map(item => item.product);
                  // console.log("LEFT productObjects - ", productObjects)
                  const updatingProductIds = new Set(productObjects.map(product => product.id));
                  const filteredUpdatedProducts = sortedLeftSideProductSet.filter(
                      product => !updatingProductIds.has(product.id)
                  );
                  sortedLeftSideProductSet = [...filteredUpdatedProducts, ...productObjects];
                  sortedLeftSideProductSet = sortedLeftSideProductSet.sort((a, b) => a.x - b.x);
              } 

              // console.log("SPACE 2 -", newChangedSpaceAmount)
              // console.log("WANT 2 -", howMuchSpaceWant)
              // console.log("X 2 -", currentX)

              // sort the moving product list by x coordinate
              movingProducts.sort((a, b) => a.x - b.x);

              if(leftSideProductSet.length === 0){
                currentX = this.getShelfXPosition(sortedInlineShelfSet, changingShelfRank, droppedFiledCustomId);
                if(currentX < cx && sortedRightSideProductSet.length > 0){
                  let righSideProdX = sortedRightSideProductSet[0].x;
                  let avalibleSpace = (righSideProdX - movingObj.drawWidth) - currentX;
                  if(avalibleSpace + movingObj.drawWidth > howMuchSpaceWant){
                    currentX = righSideProdX - movingObj.drawWidth;
                  }
                }
              }else{
                // Adjust movingProductSet product set
                let leftSideLastProdXandWidth = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
                currentX = leftSideLastProdXandWidth;
                if(currentX < cx && sortedRightSideProductSet.length > 0 && needToAdjustLeftProducts.length === 0){
                  let righSideProdX = sortedRightSideProductSet[0].x;
                  let avalibleSpace = (righSideProdX - movingObj.drawWidth) - leftSideLastProdXandWidth;
                  if(avalibleSpace + movingObj.drawWidth > howMuchSpaceWant){
                    currentX = righSideProdX - movingObj.drawWidth;
                  }
                }
              }

              // console.log("SPACE 3 -", newChangedSpaceAmount)
              // console.log("WANT 3 -", howMuchSpaceWant)
              // console.log("X 3 -", currentX)

              // Update the moving product x coordinate
              for (let i = 0; i < movingProducts.length; i++){
                const prod = movingProducts[i];
                prod.x = currentX;
                prod.shelfrank = changingShelfRank;
                prod.field_custom_id = droppedFiledCustomId;
                prod.masterFieldId = droppedFieldMasterFieldId;
                prod.y = changingShelfHeight - prod.drawHeight;
                prod.startingPoint = prod.x / this.props.displayratio;
                // prod.isHanged = false;
                currentX = prod.x + prod.drawWidth; 
                newChangedSpaceAmount = newChangedSpaceAmount + prod.drawWidth;
              }

              // console.log("SPACE 4 -", newChangedSpaceAmount)
              // console.log("WANT 4 -", howMuchSpaceWant)
              // console.log("X 4 -", currentX)

              let needToAdjustRightProducts = [];
              // check the RIGHT side spacing if avaiable
              if (roundOffDecimal(newChangedSpaceAmount,2) < roundOffDecimal(howMuchSpaceWant,2) && sortedRightSideProductSet?.length > 0) {

                for (let i = 0; i < sortedRightSideProductSet.length; i++) {
                  const currentProduct = sortedRightSideProductSet[i];
                  const nextProduct = sortedRightSideProductSet[i + 1] || null;
                  let adjustableSpace = 0;

                  if(nextProduct){
                    adjustableSpace = nextProduct.x - (currentProduct.x + currentProduct.drawWidth);
                  }else{
                    // align to shelf x end coordnate
                    let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, sortedRightSideProductSet[0]?.shelfrank, sortedRightSideProductSet[0]?.field_custom_id);
                    if(shelfXWithWidth > currentProduct.x + currentProduct.drawWidth){
                      adjustableSpace = shelfXWithWidth - (currentProduct.x + currentProduct.drawWidth);
                    }
                  }

                  // push to updating array
                  needToAdjustRightProducts.push({product: currentProduct, plusSpace: adjustableSpace });
                  newChangedSpaceAmount += adjustableSpace;

                  if(newChangedSpaceAmount >= howMuchSpaceWant) break;
                }

                // console.log("RIGTH ADJUST PRDO - ",needToAdjustRightProducts)

                for (let i = 0; i < needToAdjustRightProducts.length; i++) {
                  const product = needToAdjustRightProducts[i].product;
                  const plusSpace = needToAdjustRightProducts[i].plusSpace;

                  // Update product.x and startingPoint
                  product.x = currentX + plusSpace;
                  product.startingPoint = product.x / this.props.displayratio;
                  currentX =  product.x + product.drawWidth;
                }

                // update update product set to sortedRightSideProductSet
                const productObjects = needToAdjustRightProducts.map(item => item.product);

                const updatingProductIds = new Set(productObjects.map(product => product.id));
                const filteredUpdatedProducts = sortedRightSideProductSet.filter(
                    product => !updatingProductIds.has(product.id)
                );
                sortedRightSideProductSet = [...filteredUpdatedProducts, ...productObjects];
                sortedRightSideProductSet = sortedRightSideProductSet.sort((a, b) => a.x - b.x);

                // console.log("SPACE 5 -", newChangedSpaceAmount)
                // console.log("WANT 5 -", howMuchSpaceWant)
                // console.log("X 5 -", currentX)
            }else{
              // console.log("SPACE 6 -", newChangedSpaceAmount)
              // console.log("WANT 6 -", howMuchSpaceWant)
              // console.log("X 6 -", currentX)
              // this condition only apply, moving product last product overlap the right side products
              if( sortedRightSideProductSet?.length > 0){
                sortedRightSideProductSet = sortedRightSideProductSet.sort((a, b) => a.x - b.x);
                if(currentX > sortedRightSideProductSet[0].x){
                  let startingX = currentX;
                  for (let i = 0; i < sortedRightSideProductSet.length; i++) {
                      const prod = sortedRightSideProductSet[i]; 
                      const nextProd = sortedRightSideProductSet[i+1] || null; 
                      prod.x = currentX;
                      prod.startingPoint = prod.x / this.props.displayratio;
                      currentX = prod.x + prod.drawWidth;
                      if(currentX > startingX && nextProd){
                        if(nextProd.x > currentX){
                          // this one prevent all right side products updating
                          break;
                        }
                      }
                  } 
                }
              }
            }
          }

          // Handle Left side spacing
          if(getSpacingDirection === "LEFT"){
            // console.log("SPACE 1 -", newChangedSpaceAmount)
            // console.log("WANT 1 -", howMuchSpaceWant)
            // console.log("X 1 -", currentX)

            if (roundOffDecimal(newChangedSpaceAmount,2) < roundOffDecimal(howMuchSpaceWant,2) && sortedLeftSideProductSet?.length > 0) {
                let needToAdjustProducts = [];
            
                for (let i = sortedLeftSideProductSet.length - 1; i >= 0; i--) {
                  let adjustableSpace = 0;
                  const currentProduct = sortedLeftSideProductSet[i];
                  const previousProduct = sortedLeftSideProductSet[i - 1] || null;

                  if(previousProduct){
                      adjustableSpace = currentProduct.x - (previousProduct.x + previousProduct.drawWidth);
                      // let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                      // handle the space optimization before the assign shelf start x
                      // if(adjustableSpace > howMuchSpaceWant && cx + movingObj.drawWidth < shelfXWithWidth){
                      if(adjustableSpace > howMuchSpaceWant){
                        adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount;
                      }
                  }else{
                      // align to shelf x coordnate
                      let shelfX = this.getShelfXPosition(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                      // let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, leftSideProductSet[i]?.shelfrank, leftSideProductSet[i]?.field_custom_id);
                      if(shelfX < currentProduct.x){
                        // adjustableSpace = currentProduct.x - shelfX;
                        adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount; 
                        // handle the space optimization before the assign shelf start x
                        // if(adjustableSpace > howMuchSpaceWant && roundOffDecimal(cx + movingObj.drawWidth,2) < roundOffDecimal(shelfXWithWidth,2)){
                        //   adjustableSpace = howMuchSpaceWant - newChangedSpaceAmount; 
                        // }
                      }
                  }

                  // push to updating array
                  needToAdjustProducts.push({product: currentProduct, reduceSpace: adjustableSpace });
                  newChangedSpaceAmount += adjustableSpace;

                  if(newChangedSpaceAmount >= howMuchSpaceWant) break;
                }

                // console.log("LEFT ADJUST PRDO - ",needToAdjustProducts)
                // update the new x values
                for (let i = 0; i < needToAdjustProducts.length; i++) {
                  const product = needToAdjustProducts[i].product;
          
                  // need to assign total x value to get correct coordinate
                  const sumValue = needToAdjustProducts
                    .slice(i) // Take the current and subsequent objects
                    .reduce((sum, item) => sum + item.reduceSpace, 0);

                  product.x = product.x - sumValue;
                  product.startingPoint = product.x / this.props.displayratio;
                }

                // update update product set to sortedLeftSideProductSet
                const productObjects = needToAdjustProducts.map(item => item.product);
                // console.log("LEFT productObjects - ", productObjects)
                const updatingProductIds = new Set(productObjects.map(product => product.id));
                const filteredUpdatedProducts = sortedLeftSideProductSet.filter(
                    product => !updatingProductIds.has(product.id)
                );
                sortedLeftSideProductSet = [...filteredUpdatedProducts, ...productObjects];
                sortedLeftSideProductSet = sortedLeftSideProductSet.sort((a, b) => a.x - b.x);
            } 

            // console.log("SPACE 2 -", newChangedSpaceAmount)
            // console.log("WANT 2 -", howMuchSpaceWant)
            // console.log("X 2 -", currentX)

            // sort the moving product list by x coordinate
            movingProducts.sort((a, b) => a.x - b.x);

            if(leftSideProductSet.length === 0 && movingProducts.length > 0){
              currentX = this.getShelfXPosition(sortedInlineShelfSet, changingShelfRank, droppedFiledCustomId);
            }else{
              // Adjust movingProductSet product set
              currentX = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
            }

            // console.log("SPACE 3 -", newChangedSpaceAmount)
            // console.log("WANT 3 -", howMuchSpaceWant)
            // console.log("X 3 -", currentX)

            // Update the moving product x coordinate
            for (let i = 0; i < movingProducts.length; i++){
              const prod = movingProducts[i];
              prod.x = currentX;
              prod.shelfrank = changingShelfRank;
              prod.field_custom_id = droppedFiledCustomId;
              prod.masterFieldId = droppedFieldMasterFieldId;
              prod.y = changingShelfHeight - prod.drawHeight;
              prod.startingPoint = prod.x / this.props.displayratio;
              // prod.isHanged = false;
              currentX = prod.x + prod.drawWidth; 
              newChangedSpaceAmount = newChangedSpaceAmount + prod.drawWidth;
            }

            // console.log("SPACE 4 -", newChangedSpaceAmount)
            // console.log("WANT 4 -", howMuchSpaceWant)
            // console.log("X 4 -", currentX)
          }

          // Handle Right side spacing 
          if(getSpacingDirection === "RIGHT"){
            if(sortedLeftSideProductSet.length === 0 && movingProducts.length > 0){
              currentX = cx;
            }else{
              let leftSideLastProduct = sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].x + sortedLeftSideProductSet[sortedLeftSideProductSet.length - 1].drawWidth;
              if(cx > leftSideLastProduct){
                currentX = cx;
              }else{
                currentX = leftSideLastProduct;
              }
            }

            // sort the moving product list by x coordinate
            movingProducts.sort((a, b) => a.x - b.x);


            // console.log("RIGHT SPACE 3 -", newChangedSpaceAmount)
            // console.log("RIGHT WANT 3 -", howMuchSpaceWant)
            // console.log("RIGHT X 3 -", currentX)

            // Update the moving product x coordinate
            for (let i = 0; i < movingProducts.length; i++){
              const prod = movingProducts[i];
              prod.x = currentX;
              prod.shelfrank = changingShelfRank;
              prod.field_custom_id = droppedFiledCustomId;
              prod.masterFieldId = droppedFieldMasterFieldId;
              prod.y = changingShelfHeight - prod.drawHeight;
              prod.startingPoint = prod.x / this.props.displayratio;
              // prod.isHanged = false;
              currentX = prod.x + prod.drawWidth; 
            }

            // console.log("RIGHT SPACE 4 -", newChangedSpaceAmount)
            // console.log("RIGHT WANT 4 -", howMuchSpaceWant)
            // console.log("RIGHT X 4 -", currentX)

            // check the RIGHT side spacing if avaiable
            if (roundOffDecimal(newChangedSpaceAmount,2) < roundOffDecimal(howMuchSpaceWant,2) && sortedRightSideProductSet?.length > 0) {
                let needToAdjustProducts = [];

                for (let i = 0; i < sortedRightSideProductSet.length; i++) {
                  const currentProduct = sortedRightSideProductSet[i];
                  const nextProduct = sortedRightSideProductSet[i + 1] || null;
                  let adjustableSpace = 0;

                  if(nextProduct){
                    adjustableSpace = nextProduct.x - (currentProduct.x + currentProduct.drawWidth);
                  }else{
                    // align to shelf x end coordnate
                    let shelfXWithWidth = this.getShelfXPositionWithShelfWidth(sortedInlineShelfSet, sortedRightSideProductSet[0]?.shelfrank, sortedRightSideProductSet[0]?.field_custom_id);
                    if(shelfXWithWidth > currentProduct.x + currentProduct.drawWidth){
                      adjustableSpace = shelfXWithWidth - (currentProduct.x + currentProduct.drawWidth);
                    }
                  }

                  // push to updating array
                  needToAdjustProducts.push({product: currentProduct, plusSpace: adjustableSpace });
                  newChangedSpaceAmount += adjustableSpace;

                  if(newChangedSpaceAmount >= howMuchSpaceWant) break;
                }

                // console.log("RIGTH ADJUST PRDO - ",needToAdjustProducts)

                for (let i = 0; i < needToAdjustProducts.length; i++) {
                  const product = needToAdjustProducts[i].product;
                  const plusSpace = needToAdjustProducts[i].plusSpace;

                  // Update product.x and startingPoint
                  product.x = currentX;
                  product.startingPoint = product.x / this.props.displayratio;
                  currentX = product.x  +  product.drawWidth;
                }

                // update update product set to sortedRightSideProductSet
                const productObjects = needToAdjustProducts.map(item => item.product);

                const updatingProductIds = new Set(productObjects.map(product => product.id));
                const filteredUpdatedProducts = sortedRightSideProductSet.filter(
                    product => !updatingProductIds.has(product.id)
                );
                sortedRightSideProductSet = [...filteredUpdatedProducts, ...productObjects];
                sortedRightSideProductSet = sortedRightSideProductSet.sort((a, b) => a.x - b.x);

                // console.log("RIGHT SPACE 5 -", newChangedSpaceAmount)
                // console.log("RIGHT WANT 5 -", howMuchSpaceWant)
                // console.log("RIGHT X 5 -", currentX)
            }

          }


        // console.log("FINAL - sortedLeftSideProductSet - ",sortedLeftSideProductSet)
        // console.log("FINAL - sortedRightSideProductSet - ",sortedRightSideProductSet)
        let updatedArray = sortedLeftSideProductSet.concat(sortedRightSideProductSet);
        updatedArray = updatedArray.concat(movingProducts);
        // console.log("FINAL - updatedArray - ", updatedArray)
        return {needToReArrange, updatedProducts:updatedArray};


        // ---------------------------------------------------------------------
        // ---------------------------------------------------------------------
        // AUTO LEFT ALIGN ALL PRODUCTS ----------------------------------------
        // OLD Version ---------------------------------------------------------
        // ---------------------------------------------------------------------
       
        // // Group products by groupId
        // const groupedProducts = existingProductSet
        // .filter(product => !movingProductIds.has(product.id)) // Remove movingObj products
        // .filter(product => !product.isDelete) // Remove products with isDelete = true
        // .reduce((acc, product) => {
        //     if (!acc[product.groupId]) {
        //         acc[product.groupId] = [];
        //     }
        //     acc[product.groupId].push(product);
        //     return acc;
        // }, {});

        // // Separate products into left and right side sets based on group logic
        // let leftSideProductSet = [];
        // let rightSideProductSet = [];

        // Object.values(groupedProducts).forEach(group => {
        //     // Check the position of the first product in the group
        //     if (group.some(product => product.x < MOStartX)) {
        //         // If any product in the group goes to the left side, all go to the left side
        //         leftSideProductSet.push(...group);
        //     // } else if (group.some(product => product.x >= MOEndX)) {
        //     } else if (group.some(product => product.x >= MOStartX)) {
        //         // If any product in the group goes to the right side, all go to the right side
        //         rightSideProductSet.push(...group);
        //     }
        // });

        // // Sort left side products by x
        // leftSideProductSet.sort((a, b) => a.x - b.x);

        // // Adjust left side products
        // let currentX = 0;

        // if(leftSideProductSet.length > 0){
        //   currentX = this.getShelfXPosition(sortedInlineShelfSet, leftSideProductSet[0]?.shelfrank, leftSideProductSet[0]?.field_custom_id)
        // }

        // for (let i = 0; i < leftSideProductSet.length; i++) {
        //     const prod = leftSideProductSet[i]; 
        //     prod.x = currentX; // Adjust x to start after MOEndX 
        //     currentX = prod.x + prod.drawWidth; // Update for next product
        //     prod.startingPoint = prod.x / this.props.displayratio; // Update startingPoint
        // }

        // // Set currentX to the last product's x + drawWidth in the left array
        // if (leftSideProductSet.length > 0) {
        //   currentX = leftSideProductSet[leftSideProductSet.length - 1].x + 
        //             leftSideProductSet[leftSideProductSet.length - 1].drawWidth;
        // } else {
        //   currentX = MOStartX; // Fallback to MOStartX if left array is empty
        // }

        // if(leftSideProductSet.length === 0 && movingProducts.length > 0){
        //   currentX = this.getShelfXPosition(sortedInlineShelfSet, changingShelfRank, droppedFiledCustomId)
        // }

        // // Sort right side products by x
        // movingProducts.sort((a, b) => a.x - b.x);
        // // Adjust movingProductSet product set
        // for (let i = 0; i < movingProducts.length; i++){
        //   const prod = movingProducts[i];
        //   prod.x = currentX;
        //   prod.shelfrank = changingShelfRank;
        //   prod.field_custom_id = droppedFiledCustomId;
        //   prod.masterFieldId = droppedFieldMasterFieldId;
        //   prod.y = changingShelfHeight - prod.drawHeight;
        //   prod.startingPoint = prod.x / this.props.displayratio;
        //   currentX = prod.x + prod.drawWidth; 
        // }

        // // Set currentX to the last product's x + drawWidth in movingProducts
        // if (movingProducts.length > 0) {
        //   currentX = movingProducts[movingProducts.length - 1].x + 
        //             movingProducts[movingProducts.length - 1].drawWidth;
        // } else {
        //   currentX = MOEndX; // Fallback to MOEndX if movingProducts is empty
        // }

        // // Sort right side products by x
        // rightSideProductSet.sort((a, b) => a.x - b.x);

        // for (let i = 0; i < rightSideProductSet.length; i++) {
        //     const prod = rightSideProductSet[i]; 
        //     prod.x = currentX; // Adjust x to start after MOEndX 
        //     currentX = prod.x + prod.drawWidth; // Update for next product
        //     prod.startingPoint = prod.x / this.props.displayratio; // Update startingPoint
        // }

        // let updatedArray = leftSideProductSet.concat(rightSideProductSet);
        // updatedArray = updatedArray.concat(movingProducts);
        // return {needToReArrange, updatedProducts:updatedArray};

        // ---------------------------------------------------------------------
        // ---------------------------------------------------------------------
        // AUTO LEFT ALIGN ALL PRODUCTS ----------------------------------------
        // ---------------------------------------------------------------------
        // ---------------------------------------------------------------------
      }
      return {needToReArrange};
    }

    getShelfXPosition(inlineShelfSet, prodShelfRank, prodFiledCustomId) {
      // Find the matching shelf in the inlineShelfSet
      // const matchingShelf = inlineShelfSet.find(shelf => 
      //     shelf.rank === prodShelfRank &&
      //     shelf.field_custom_id === prodFiledCustomId
      // );
      const matchingShelf = inlineShelfSet.find(shelf => 
          shelf.rank === prodShelfRank 
      );
      return matchingShelf ? matchingShelf.x : 0;
    }

    getShelfXPositionWithShelfWidth(inlineShelfSet, prodShelfRank, prodFiledCustomId) {
      const matchingShelf = inlineShelfSet.find(shelf => 
          shelf.rank === prodShelfRank &&
          shelf.field_custom_id === prodFiledCustomId
      );
      return matchingShelf ? (matchingShelf.x + matchingShelf.drawWidth) : 0;
    }

    // Verify and correct product x positions to ensure proper alignment
    // Each product's (x + drawWidth) should equal the next product's x value
    verifyAndCorrectProductPositions = (movingProductSet) => {
      if (!movingProductSet || movingProductSet.length === 0) {
        return movingProductSet;
      }

      // Sort products by their x position to ensure correct order
      let sortedProducts = [...movingProductSet].sort((a, b) => a.x - b.x);

      // Verify and correct each product's position
      for (let i = 0; i < sortedProducts.length - 1; i++) {
        const currentProduct = sortedProducts[i];
        const nextProduct = sortedProducts[i + 1];

        // Calculate where the next product should start
        const expectedNextX = roundOffDecimal(currentProduct.x + currentProduct.drawWidth, 2);
        const actualNextX = roundOffDecimal(nextProduct.x, 2);

        // If there's a mismatch, correct the next product's x position
        if (expectedNextX !== actualNextX) {
          nextProduct.x = expectedNextX;
          nextProduct.startingPoint = nextProduct.x / this.props.displayratio;
        }
      }

      return sortedProducts;
    }

    // find the direction to optimized the spacing
    getDirectionToOptimizedTheGetProductSpacing(cx, movingObjectWidth, shelfStartX, shelfTotalWidth, leftProducts, rightProducts){
      // console.log("CHECKING - cx", cx);
      // console.log("CHECKING - movingObjectWidth", movingObjectWidth);
      // console.log("CHECKING - shelfStartX", shelfStartX);
      // console.log("CHECKING - shelfTotalWidth", shelfTotalWidth);
      // console.log("CHECKING - leftProducts", leftProducts);
      // console.log("CHECKING - rightProducts", rightProducts);

      const movingEndX = cx + movingObjectWidth;
      let crossesLeft = false;
      let crossesRight = false;
  
      // Check if it crosses left products
      for (const product of leftProducts) {
          const productStartX = product.x;
          const productEndX = product.x + product.drawWidth;
          if (movingEndX > productStartX && cx < productEndX) {
              crossesLeft = true;
              break;
          }
      }
  
      // Check if it crosses right products
      for (const product of rightProducts) {
          const productStartX = product.x;
          const productEndX = product.x + product.drawWidth;
          if (movingEndX > productStartX && cx < productEndX) {
              crossesRight = true;
              break;
          }
      }
  
      let leftSpace = 0;
      let rightSpace = 0;
  
      let totalLeftProductWidth = 0;
      for (const product of leftProducts) {
        totalLeftProductWidth += product.drawWidth;
      }
      // console.log("LEFT PROD", totalLeftProductWidth)
      leftSpace = (cx - shelfStartX) - totalLeftProductWidth;
      if (leftSpace < 0) leftSpace = 0;
      // console.log("LEFT REST", leftSpace)
  
      let totalRightProductWidth = 0;
      for (const product of rightProducts) {
        totalRightProductWidth += product.drawWidth;
      }
      // console.log("RIGHT PROD", totalRightProductWidth)
      rightSpace =((shelfStartX + shelfTotalWidth) - (cx + movingObjectWidth)) - totalRightProductWidth;
      if (rightSpace < 0) rightSpace = 0;
      // console.log("RIGHT REST", rightSpace)
  
      let direction = "NONE";
      if (crossesLeft && crossesRight) {
          direction = "BOTH";
      } else if (crossesLeft) {
          direction = "LEFT";
      } else if (crossesRight) {
          direction = "RIGHT";
      }
  
      return { direction, leftSpace, rightSpace };
    }


    findShelfSpacesSVG(shelf, products) {
      const totalShelfWidth = shelf.drawWidth; // Total width of the shelf in SVG units
      const shelfStartX = shelf.x; // Starting X position of the shelf in SVG
      const shelfEndX = shelfStartX + totalShelfWidth; // Ending X position of the shelf
    
      // Filter and sort products by their x position
      const sortedProducts = products
        .filter(product => product.x + product.drawWidth > shelfStartX && product.x < shelfEndX) // Filter products within the shelf bounds
        .sort((a, b) => a.x - b.x); // Sort by starting position
    
      const unusedSpaces = [];
      let lastEnd = shelfStartX; // Initialize with the start of the shelf
    
      for (const product of sortedProducts) {
        const productStart = Math.max(product.x, shelfStartX); // Clamp product start to shelf start
        const productEnd = Math.min(product.x + product.drawWidth, shelfEndX); // Clamp product end to shelf end
    
        // Check if there's a gap before this product
        if (productStart > lastEnd) {
          unusedSpaces.push({ start: lastEnd, end: productStart });
        }
    
        // Update lastEnd to the maximum of its current value or the current product's end
        lastEnd = Math.max(lastEnd, productEnd);
      }
    
      // Check for a gap after the last product
      if (lastEnd < shelfEndX) {
        unusedSpaces.push({ start: lastEnd, end: shelfEndX });
      }
    
      return unusedSpaces;
    }
    
    
    

    //#PDU-SM12
    resetToOriginalState = () => {
      let resetobj = JSON.parse(JSON.stringify(this.state.bkpBlockObj));
      let blockobj = this.state.selectBlockObj;
      const me = d3.select(this["LM01"]);
      me.attr('x', resetobj?.x);
      me.attr('y', resetobj?.y);
  
      blockobj.x = resetobj?.x;
      blockobj.y = resetobj?.y;

      this.setState({ selectBlockObj: blockobj });
    }


    // PEG CR - 2025 March
    //handle the peg product drop from the field
    handleProductsDropInsidePegBoard = (evt,cx,cy, droppedPegBoard) =>{
      let movingProductObj = structuredClone(this.state.selectBlockObj);
      let mapproductList = this.props.mapproductList; 
      let pegProductList = this.props.pegProductList;
      let pegBoard = droppedPegBoard;
      let deletedProductList = [];
      let newProductList = [];
      let errorMessagesList = [];

      // find the product hanging hole position
      let products = movingProductObj?.drawingProducts;
      // filter is hangged product list which is selected pegboard
      let filteredPegProductList = mapproductList.filter(prod => prod.pegBoardIndex === pegBoard.pegBoardIndex);

      // filtered filteredPegProductList from is delete false products
      filteredPegProductList = filteredPegProductList.filter(prod => !prod.isDelete);

      // remove moving product set from filteredPegProductList
      filteredPegProductList = filteredPegProductList.filter(p => !products.some(prod => prod.id === p.id));

      // drop x & y
      let dropX = cx;
      let dropY = cy;


      products.forEach((prod,i)=>{
        // check if have not hangable product
        if(!prod?.isHangable){
          //  alertService.error(i18n.t("NOT_HANGABLE_PRODUCT"),4000);
          errorMessagesList.push({errorCode: "NOT_HANGABLE_PRODUCT"});
          return;
        }

        const productHoleXPos = (measureConverter(prod?.uom ,"cm",prod?.haggingHorizontal)*this.props.displayratio);
        const productHoleYPos = (measureConverter(prod?.uom ,"cm",prod?.haggingVertical)*this.props.displayratio);

        const convertGapH = pegBoard?.drawGapH;
        const convertGapV = pegBoard?.drawGapW;

        // For products with price tag, calculate hole position from center (price tag center on peg hole)
        // For products without price tag, use hanging hole position
        const productHoleX = dropX + productHoleXPos;
        const productHoleY = dropY + productHoleYPos;

        // check if some product overlap
        const {isOverlap, issueType} =  this.productOverlapChecker(pegBoard, [...filteredPegProductList, ...newProductList], prod, dropX, dropY);
        if(isOverlap){
          //  alertService.error(i18n.t("HANGABLE_PRODUCT_OVERLAP"),4000);
          if(issueType === "HANGABLE_PRODUCT_OVERLAP"){
            errorMessagesList.push({errorCode: "HANGABLE_PRODUCT_OVERLAP"});
          }else if(issueType ==="PEG_BOARD_OVERLAP"){
            errorMessagesList.push({errorCode: "PEG_BOARD_OVERLAP"});
          }
          return;
        } 
  
        let nearestPeg = null;
        // find the nearest peg within acceptable range (1.5x gap for tolerance)
        const maxThresholdX = convertGapH * 1.5;
        const maxThresholdY = convertGapV * 1.5;
        nearestPeg = this.findNearestPeg(pegBoard?.pegCoordinations, productHoleX, productHoleY, maxThresholdX, maxThresholdY, prod);

        if(nearestPeg === null){
          //  alertService.error(i18n.t("CANNOT_FIND_THE_FREE_PEG_HOLE"),4000);
          errorMessagesList.push({errorCode: "CANNOT_FIND_THE_FREE_PEG_HOLE"});
          return;
        }

        if(nearestPeg){
          const updatedProductX = nearestPeg.drawX - productHoleXPos;
          const updatedProductY = nearestPeg.drawY - productHoleYPos;
          // check if product is already available in the pegProductList
          const existingProduct = pegProductList.find(pegprod => pegprod.id === prod.id);

          let prodCopy = JSON.parse(JSON.stringify(prod));  
          let newProduct = structuredClone(prodCopy);  

          // update the product x and y position
          newProduct.x = updatedProductX;
          newProduct.y = updatedProductY;

          // check if some product overlap
          // Pass nearestPeg.drawX and nearestPeg.drawY as the peg center for price tag calculation
          const {isOverlap, issueType} =  this.productOverlapChecker(pegBoard, [...filteredPegProductList, ...newProductList], newProduct, updatedProductX, updatedProductY, nearestPeg.drawY, nearestPeg.drawX);
          if(isOverlap){
            if(issueType === "HANGABLE_PRODUCT_OVERLAP"){
              errorMessagesList.push({errorCode: "HANGABLE_PRODUCT_OVERLAP"});
            }else if(issueType ==="PEG_BOARD_OVERLAP"){
              errorMessagesList.push({errorCode: "PEG_BOARD_OVERLAP"});
            }
            return;
          } 

          if(existingProduct == null || existingProduct == undefined){
            newProduct.id = uuidv4();
            newProduct.pegProductId = uuidv4();
          }
          newProduct.startingPoint = updatedProductX / this.props.displayratio;
          // peg details
          newProduct.pegBoardId = pegBoard.id;
          newProduct.pegBoardIndex = pegBoard.pegBoardIndex,
          newProduct.pegBoardName = pegBoard.name;
          newProduct.isHanged = true;
          newProduct.pegRefCode = nearestPeg.refCode;
          newProduct.pegX = nearestPeg.x;
          newProduct.pegDrawX = nearestPeg.drawX;
          newProduct.pegY = nearestPeg.y;
          newProduct.pegDrawY = nearestPeg.drawY;

          // update is delete to moved products
          prod.isDelete = true;

          deletedProductList.push(prod);
          newProductList.push(newProduct);
          // update drop x & y
          // dropX = nearestPeg.drawX + productHoleXPos + convertGapV/2; // OLD METHOD
          dropX = nearestPeg.drawX + prod.drawWidth;
          dropY = cy;
        }

      })

      // check if have some error messages 
      if(errorMessagesList.length > 0){
          // remove duplicate error codes
          errorMessagesList = errorMessagesList.filter((value, index, self) =>
              index === self.findIndex((t) => (
                  t.errorCode === value.errorCode
              ))
          );
          
          // show error messages
          let errorMessage = errorMessagesList.map((error) => {
              if(error.errorCode === "NOT_HANGABLE_PRODUCT"){
                  return i18n.t("NOT_HANGABLE_PRODUCT");
              }else if(error.errorCode === "HANGABLE_PRODUCT_OVERLAP"){
                  return i18n.t("HANGABLE_PRODUCT_OVERLAP");
              }else if(error.errorCode === "CANNOT_FIND_THE_FREE_PEG_HOLE"){
                  return i18n.t("CANNOT_FIND_THE_FREE_PEG_HOLE");
              }else if(error.errorCode === "PEG_BOARD_OVERLAP"){
                  return i18n.t("PEG_BOARD_OVERLAP");
              }
          });
          alertService.error(errorMessage,4000);
          this.setState({selectBlockObj:null});
          this.props.resetSelectBlockObjData();
          return;
      };

      // set product to mapproductList
      let existingProductsCopy = JSON.parse(JSON.stringify(mapproductList));
      let existingProducts = structuredClone(existingProductsCopy);
      let existingPegProductsCopy = JSON.parse(JSON.stringify(pegProductList));
      let existingPegProducts = structuredClone(existingPegProductsCopy);

      // remove product object from mapproductList
      const restProductList = existingProducts.filter(prod => !deletedProductList.some(deletedProd => deletedProd.id === prod.id));

      // remove peg product from essiting array
      const restPegProductList = existingPegProducts.filter(prod => !deletedProductList.some(deletedProd => deletedProd.id === prod.id));

      let historydata=JSON.parse(JSON.stringify(this.props.mapproductList))
      this.props.fieldHistoryAdd(historydata,1);
      this.props.handlePegProductAdd([...restPegProductList, ...newProductList]);
      this.props.updateProductList([...restProductList, ...deletedProductList, ...newProductList],false);
    }

    // PEG CR - 2025 March
    // this function will return the nearest peg hole
    // prod is optional - for price tag products, converts hanging hole position to price tag center
    findNearestPeg = (pegCoordinations, productHoleX, productHoleY, thresholdX, thresholdY, prod = null) => {
      let nearestPeg = null;
      let minDistance = Infinity;

      let searchX = productHoleX;
      let searchY = productHoleY;
      const hasPriceTag = prod?.hasPriceTag;
      if (hasPriceTag) {
          const productHoleXPos = measureConverter(prod?.uom, "cm", prod?.haggingHorizontal) * this.props.displayratio;
          const productHoleYPos = measureConverter(prod?.uom, "cm", prod?.haggingVertical) * this.props.displayratio;
          const productDrawWidth = measureConverter(prod?.uom, this.props.displayuom, prod?.width) * this.props.displayratio;
          const priceTagHeightPx = (prod?.product?.priceTagHeightLatest || prod?.priceTagHeightLatest || prod?.priceTagHeight || 0) * this.props.displayratio;
          // Replace hanging hole offset with price tag center offset
          searchX = productHoleX - productHoleXPos + (productDrawWidth / 2);
          searchY = productHoleY - productHoleYPos + (priceTagHeightPx / 2);
      }

      for (const peg of pegCoordinations) {
        const deltaX = Math.abs(peg.drawX - searchX);
        const deltaY = Math.abs(peg.drawY - searchY);

        // Check if peg is within threshold
        if (deltaX <= thresholdX && deltaY <= thresholdY) {
          // Calculate Euclidean distance
          const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

          // Update if this is the nearest peg so far
          if (distance < minDistance) {
            minDistance = distance;
            nearestPeg = peg;
          }
        }
      }

      return nearestPeg;
    }

    // PEG CR - 2025 March
    // This function will return if product overlap in the exiting product set int peg board
    // newPegDrawY is the peg center Y for the new product being dropped (optional, used for price tag calculation)
    // newPegDrawX is the peg center X for the new product being dropped (optional, used for price tag X calculation)
    productOverlapChecker = (pegBoard, existingProductList, newProduct, cx, cy, newPegDrawY = null, newPegDrawX = null) => {

      // remove the dropping product if avaliable the
      let existingPegProducts = existingProductList.filter((prod)=>prod?.id != newProduct?.id);
      // remove the other peg boards products
      existingPegProducts = existingPegProducts.filter((prod)=>prod?.pegBoardIndex == pegBoard?.pegBoardIndex || prod?.pegBoardId == pegBoard?.id);

      const productWidth = newProduct?.drawWidth;
      // Calculate total height including price tag if hasPriceTag is true for new product
      const newPriceTagHeightPx = newProduct?.hasPriceTag ? (newProduct?.priceTagHeight * this.props.displayratio) : 0;
      const newGapPx = newProduct?.hasPriceTag ? (newProduct?.priceTagGap * this.props.displayratio) : 0;
      const productHeight = (newProduct?.isHanged && newProduct?.hasPriceTag)
          ? newPriceTagHeightPx + newGapPx + newProduct?.drawHeight
          : newProduct?.drawHeight;
      // For new product with price tag, Y starts at pegDrawY - (priceTagHeight/2)
      // Use newPegDrawY if provided, otherwise fall back to cy
      const newProductY = (newProduct?.isHanged && newProduct?.hasPriceTag && newPegDrawY)
          ? newPegDrawY - (newPriceTagHeightPx / 2)
          : cy;
      // For new product with price tag, X is centered on peg hole: pegDrawX - (drawWidth/2)
      const newProductX = (newProduct?.isHanged && newProduct?.hasPriceTag && newPegDrawX)
          ? newPegDrawX - (productWidth / 2)
          : cx;

      // Check for overlap with any existing products on the peg board
      for (let existingProduct of existingPegProducts) {
          // For existing products with price tag, X is centered on peg hole: pegDrawX - (drawWidth/2)
          const existingWidth = existingProduct?.drawWidth;
          const existingX = (existingProduct?.isHanged && existingProduct?.hasPriceTag && existingProduct?.pegDrawX !== undefined)
              ? existingProduct.pegDrawX - (existingWidth / 2)
              : existingProduct?.x;
          // Calculate price tag dimensions for existing product
          const existingPriceTagHeightPx = existingProduct?.hasPriceTag ? (existingProduct?.priceTagHeight * this.props.displayratio) : 0;
          const existingGapPx = existingProduct?.hasPriceTag ? (existingProduct?.priceTagGap * this.props.displayratio) : 0;
          // For products with price tag, Y starts at pegDrawY - (priceTagHeight/2)
          // pegDrawY is the peg hole center, price tag is centered on it
          const existingY = (existingProduct?.isHanged && existingProduct?.hasPriceTag && existingProduct?.pegDrawY !== undefined)
              ? existingProduct.pegDrawY - (existingPriceTagHeightPx / 2)
              : existingProduct?.y;
          // Calculate total height including price tag if hasPriceTag is true for existing product
          const existingHeight = (existingProduct?.isHanged && existingProduct?.hasPriceTag)
              ? existingPriceTagHeightPx + existingGapPx + existingProduct?.drawHeight
              : existingProduct?.drawHeight;

          // check if the products is delete ture then skip the products
          if(existingProduct?.isDelete){
            continue;
          }

          const isOverlap = !(
              newProductX + productWidth <= existingX || // New product is entirely left of the existing product
              newProductX >= existingX + existingWidth || // New product is entirely right of the existing product
              newProductY + productHeight <= existingY || // New product is entirely above the existing product
              newProductY >= existingY + existingHeight // New product is entirely below the existing product
          );

          if (isOverlap) {
              // console.log("Overlap detected with product: ", existingProduct);
              return {isOverlap:true, issueType: "HANGABLE_PRODUCT_OVERLAP"};
              // need to make the function to move exisitng product and get space
          }

      }

      // check if product is in outside the peg board
      const pegBoardStartX = pegBoard?.pegDrawingRect?.drawX;
      const pegBoardStartY = pegBoard?.pegDrawingRect?.drawY;
      const pegBoardEndX = pegBoard?.pegDrawingRect?.drawX + pegBoard?.pegDrawingRect?.drawRectWidth;
      const pegBoardEndY = pegBoard?.pegDrawingRect?.drawY + pegBoard?.pegDrawingRect?.drawRectHeight;

      if (newProductX + productWidth > pegBoardEndX || newProductX < pegBoardStartX ||
          newProductY + productHeight > pegBoardEndY || newProductY < pegBoardStartY) {
          // console.log("Product is outside the peg board boundaries.");
          return {isOverlap:true, issueType: "PEG_BOARD_OVERLAP"};  // Product is outside the peg board, return overlap
      }
      // No overlap, product can be dropped at the original position
      // console.log("No overlap detected, product can be placed at the selected position.");
      return {isOverlap:false};  // No overlap, return null or appropriate result
    };


    // PEG CR - 2025 March
    // This function will return if any product overlap the peg board
    // @pegboard - all peg board data array
    // @productList - all product list
    productOverlapCheckerWithPegBoard = (pegBoard, productList) => {

      for (let i = 0; i < pegBoard.length; i++) {
        const {pegDrawingRect} = pegBoard[i];

        let pegBoardStartX = pegDrawingRect.drawX;
        let pegBoardStartY = pegDrawingRect.drawY;

        let pegBoardEndX = pegDrawingRect.drawX + pegDrawingRect.drawRectWidth;
        let pegBoardEndY = pegDrawingRect.drawY + pegDrawingRect.drawRectHeight;
        
        for (let j = 0; j < productList.length; j++) {
          let product = productList[j];
          let productStartX = product.x;
          let productStartY = product.y;
          let productEndX = product.x + product.drawWidth;
          let productEndY = product.y + product.drawHeight;

          if(product.isDelete || product.isHanged){
            continue;
          }

          if (productEndX > pegBoardStartX && productStartX < pegBoardEndX && productEndY > pegBoardStartY && productStartY < pegBoardEndY) {
            return {isPegBoardOverlap:true, product:product};
          }
        }
      }
      return {isPegBoardOverlap:false};
    }

    render() {
        //PEG CR - 2025 - When current selected block is null then set the selectBlockObj to null
        let blockobj   = this.props.currentSelectedBlock != null ? this.props.currentSelectedBlock : this.state.selectBlockObj;
        //let blockobj = this.state.selectBlockObj;
        let ghostobj   = this.props.ghostWrapperObj;

        // Get price tag info from first product in drawingProducts
        const firstProduct = blockobj?.drawingProducts?.[0];
        const hasPriceTag = firstProduct?.hasPriceTag;
        const isHanged = firstProduct?.isHanged;
        const priceTagHeight = firstProduct?.priceTagHeight || 0;
        const priceTagGap = firstProduct?.priceTagGap || 0;

        // Calculate total height including price tag if hasPriceTag is true
        const priceTagHeightPx = hasPriceTag ? (priceTagHeight * this.props.displayratio) : 0;
        const gapPx = hasPriceTag ? (priceTagGap * this.props.displayratio) : 0;
        const totalHeight = isHanged && hasPriceTag
            ? priceTagHeightPx + gapPx + (blockobj?.drawHeight || 0)
            : (blockobj?.drawHeight || 0);

        // For hanged products with price tag, align ghost rect with price tag (centered on peg hole)
        const ghostX = (isHanged && hasPriceTag && firstProduct?.pegDrawX)
            ? blockobj?.x 
            : (blockobj?.x || 0);
        const ghostY = (isHanged && hasPriceTag && firstProduct?.pegDrawY)
            ? firstProduct.pegDrawY - (priceTagHeightPx/2) 
            : (blockobj?.y || 0);

        return <g>
                  <rect onMouseDown={(e)=> this.props.handleBlockContextMenu(e,true,ghostX,ghostY,blockobj?blockobj.drawWidth:0,blockobj?totalHeight:0,blockobj.drawingProducts)}
                   x={ghostX}
                   y={ghostY}
                   width={ghostobj?ghostobj.width:blockobj?blockobj.drawWidth:0}
                   //height={ghostobj?ghostobj.height:blockobj?blockobj.drawHeight:0}
                   height={totalHeight}
                   pointerEvents="all" fill={this.props.isPegDrawing === true?'':'green'} fillOpacity={this.props.isPegDrawing === true? 0:0.3} ref={(r) => this["LM01"] = r} />

                  {/* <rect x={blockobj?blockobj.x:0} className="resize-controls-y" ref={(r) => this["rsx_left"] = r} y={blockobj?blockobj.y:0} width={"3"} height={blockobj?blockobj.drawHeight:0} fill="green" fillOpacity={"0.6"} />
                  <rect x={blockobj?((blockobj.x + blockobj.drawWidth) - 3):0} className="resize-controls-y" ref={(r) => this["rsx_right"] = r} y={blockobj?blockobj.y:0} width={"3"} height={blockobj?blockobj.drawHeight:0} fill="green" fillOpacity={"0.6"} />
                 */}
              </g>
              
    }
  }

  export function setGuidlineComman(props){
    // var evt=props.evt
    var cx = structuredClone(props.cx);
    var cy = structuredClone(props.cy);
    
    var selectBlockObj = structuredClone(props.selectBlockObj);
    var mapCatRects = props.mapCatRects;
    var mapFields = props.mapFields;
    var mapproductList = props.mapproductList;

    var previewShelves = [];
    let movingObj = JSON.parse(JSON.stringify(selectBlockObj));

    if(!movingObj){
      return;
    }
    
    var MOStartX = roundOffDecimal(cx,2);
    var MOStartY = roundOffDecimal(cy,2);
    var MOEndX = roundOffDecimal((cx + movingObj?.drawWidth),2);
    var MOEndY = roundOffDecimal((cy + movingObj?.drawHeight),2);

    var containElem = elmAccordingtoXY(cx,cy,movingObj?.drawWidth,movingObj?.drawHeight,mapFields,mapCatRects);
    
    let ghostobj = { width: 0, height: 0, selectedShelfSet: [] };
    
    var selectingField = containElem?.field;

    //console.log('selectingField_1=>', selectingField);

    const matchingField = props?.actualFieldStructuresNew?.find(
      field => field.field_id === selectingField?.masterFieldId
    );

    if(selectingField){
      var fieldStartX = roundOffDecimal(selectingField.x);
      var fieldStartY = roundOffDecimal(selectingField.y,2);
      var fieldEndX = roundOffDecimal((selectingField.x+selectingField.drawWidth+matchingField?.drawWidth),2);
      var fieldEndY = roundOffDecimal((selectingField.x+selectingField.drawHeight),2);
      
      let isinsidefield = false;
      //check inside field
      if((fieldStartX < MOStartX && fieldEndX > MOEndX) && (fieldStartY < MOStartY && fieldEndY > MOEndY)){
        isinsidefield = true;
      } else{
        if(fieldStartY < MOStartY && fieldEndY > MOEndY){
          //if item x1 is less than field x1 and item x2 not greater than field x2
          
          if(fieldStartX > MOStartX && fieldEndX > MOEndX){
            MOStartX = fieldStartX;
            isinsidefield = true;
          }
          //if item x1 is greater than field x1 and item x2 not less than field x2
          if(fieldStartX < MOStartX && fieldEndX < MOEndX){
            // MOStartX = roundOffDecimal((fieldEndX - movingObj.drawWidth),2);
            isinsidefield = true;
          }
        }

        //if block inside field but not from bottom of field
        if((fieldStartX < MOStartX && fieldEndX > MOEndX) && fieldStartY < MOStartY){
          //cy = roundOffDecimal((fieldEndY - selectingField.drawHeight),2);
          // MOStartY = roundOffDecimal((fieldEndY - selectingField.drawHeight),2);
          // MOEndY = roundOffDecimal(fieldEndY,2);
          isinsidefield = true;
        }
      }

      let previewprodlist = [];
      if(isinsidefield){
        var existingProducts = JSON.parse(JSON.stringify(mapproductList));
        let changefield = mapFields[selectingField.key];
        // console.log("loc1");
        let containProds = GetContainingProdsByBox(MOStartX , MOStartY, MOEndX, MOEndY, existingProducts, changefield, false, null, [], true);
        
        let lowestprodx = MOStartX;
        let highestprodx2 = roundOffDecimal((lowestprodx + movingObj.drawWidth),2);
        
        // let cutshelfs = []; 
        let droppingXProd = null; //to find prod available in dropping x1 position
        if(containProds && containProds.selectedProds && containProds.selectedProds.length>0){
          var notDeletedContainProds = containProds.selectedProds.filter(f => !f.isDelete);
          for (let p = 0; p < notDeletedContainProds.length; p++) {
            const prod = notDeletedContainProds[p];
            
              for (let j = 0; j < movingObj.selectedshelves.length; j++) {
                const ele = movingObj.selectedshelves[j];
                var ishaveinSlectedshleves = ele.selectedProducts.find(x=>x.id===prod.id)
                //check save moving produtcs not cutting
                if(ishaveinSlectedshleves === undefined){
                  let prodstartx = (prod.x);
                  let checkprodwidth = (((prod.drawWidth / 3) > 8)?(prod.drawWidth / 3):(prod.drawWidth / 2));
                  let prodmiddlex = (prod.x + checkprodwidth);
                  
                  if(lowestprodx > prodstartx && lowestprodx < prodmiddlex){
                    lowestprodx = prod.x;
                    highestprodx2 = roundOffDecimal((lowestprodx + movingObj.drawWidth),2);
                  }
                  

                  //left side
                  if(prod.x <= MOStartX && MOStartX <= roundOffDecimal((prod.x + prod.drawWidth),2)){
                    droppingXProd = prod;
                  }

                  //right side
                  if(!droppingXProd && (prod.x <= MOEndX && MOEndX <= roundOffDecimal((prod.x + prod.drawWidth),2))){
                    droppingXProd = prod;
                  }

                  //add lower than max dropping x2 products
                  let prodx2 = roundOffDecimal((prod.x + prod.drawWidth),2);
                  if(prodx2 <= highestprodx2){
                    previewprodlist.push(prod);
                  }
                }
              }
          }
        }
        
        let containshelfs = (selectingField.contain_shelfs?selectingField.contain_shelfs:[]);

        //if dropping position x not have product find last left product x to drop
        // commented get snapping location - (automatically magnetizes a product to another product)
        // if(!droppingXProd){
        //   lowestprodx = getSnappingLocation(lowestprodx, selectingField, existingProducts, movingObj, containshelfs);
        // }
        
        //reset guidlines
        containshelfs.forEach(conshlf => {
          conshlf.previewguid={startX:-1,endX:-1}
        });

        for (let m = 0; m < movingObj.selectedshelves.length; m++) {
          const changeshelf = movingObj.selectedshelves[m];
          var maxEndX = 0; var maxY = 0; //var maxEndY = 0;
          var stratingXofshelvf=0
          //if found
          if(containshelfs[m]){
            
            let curshelfitemy = (containshelfs[m]?(containshelfs[m].y + containshelfs[m].drawHeight):0);
            for (let k = 0; k < changeshelf.selectedProducts.length; k++) {
              const changeproditem = changeshelf.selectedProducts[k];
              let gapbetweenoribox = (changeproditem.x - movingObj.x);
              //only first time
              
              if(k===0){
                stratingXofshelvf=(lowestprodx + gapbetweenoribox);
              }
              
              changeproditem["x"] = (lowestprodx + gapbetweenoribox);
              changeproditem["y"] = (curshelfitemy - changeproditem.drawHeight);
              changeproditem["shelfrank"] = containshelfs[m].rank;
              
              existingProducts[changeproditem.prodidx] = changeproditem;
              existingProducts[changeproditem.prodidx]["isDelete"] = false;
              if(maxY<changeproditem.y){
                maxY=changeproditem.y
                // maxEndY=changeproditem.y+changeproditem.drawHeight;
              }

              let curprodendx = (changeproditem.x + changeproditem.drawWidth);
              if(curprodendx > maxEndX){
                maxEndX = curprodendx
              }
              
            } 

            
            containshelfs[m]["previewguid"] = { startX: stratingXofshelvf, endX: maxEndX };
            
            // console.log(structuredClone(containshelfs[m]));

            if(containshelfs[m].previewguid.startX > -1){
              let gapbetweenguidelines = (containshelfs[m].previewguid.endX - containshelfs[m].previewguid.startX);

              ghostobj.width = (gapbetweenguidelines > ghostobj.width?gapbetweenguidelines:ghostobj.width);
              ghostobj.height += (containshelfs[m].drawHeight + containshelfs[m].drawGap);
            }
          }
          
          
        }
        //checking inside shelf or not
        if(containElem.isInsideShelf){
          previewShelves = structuredClone(containshelfs);
        }

      } else{
        props.setPreviewGuid(true);
      }

      // New CR - 2025 Jan 13
      let selectedProductBlock = movingObj?.drawingProducts;
     
      if(selectedProductBlock && selectedProductBlock.length > 0){
        // check all products shelf rank is same or not
        let isSameShelfRank = selectedProductBlock.every((val, i, arr) => val.shelfrank === arr[0].shelfrank);
  
        if(isSameShelfRank){
          // console.log("cx-------",cx)
          // console.log("cy-------",cy)
          let currentMovingSelectedShelf = null;
          for (const shelf of previewShelves) {
            
            const startX = shelf.x;
            const endX = shelf.x+shelf.drawWidth;
            const startY = shelf.y;
            const endY = shelf.y + shelf.drawHeight;
    
            // Check if cx and cy fall within the shelf boundaries
            if (cx >= startX && cx <= endX && cy >= startY && cy <= endY) {
              currentMovingSelectedShelf = shelf
            }
          }

          // get similer shelf from selected shelf y+drawheight
          let similarLevelShelves = getSimilarLevelShelves(currentMovingSelectedShelf, mapFields , props?.actualFieldStructuresNew);

          // console.log("mapFields---------",mapFields)
          // console.log("similarLevelShelves---------",similarLevelShelves)
          
          // concat similarLevelShelves with currentMovingSelectedShelf arrays
          let selectedShelfSet = [];
          // selectedShelfSet.push(currentMovingSelectedShelf);
          selectedShelfSet = selectedShelfSet.concat(similarLevelShelves);

          let productList = JSON.parse(JSON.stringify(mapproductList));
          let exisitingProductList = getSelectedProducts(productList, selectedShelfSet, selectedProductBlock);
          // get exiting product total width
          let totalProductWidth = 0;
          exisitingProductList.forEach(product => {
            totalProductWidth += product?.drawWidth;
          });

          // get total width of selected shelf
          let totalShelfWidth = 0;
          selectedShelfSet.forEach(shelf => {
            totalShelfWidth += shelf?.drawWidth;
          });
          let restSpace = totalShelfWidth - totalProductWidth;
          // get moving product block width
          let movingProductBlockWidth = 0;
          selectedProductBlock.forEach(product => {
            movingProductBlockWidth += product?.drawWidth;
          });
          // console.log("XXXXXXXXXXXX totalProductWidth --------", roundOffDecimal(totalProductWidth,2))
          // console.log("XXXXXXXXXXXX totalShelfWidth --------", roundOffDecimal(totalShelfWidth,2))
          // console.log("XXXXXXXXXXXX restSpace --------", roundOffDecimal(restSpace,2))
          // console.log("XXXXXXXXXXXX movingProductBlockWidth --------", roundOffDecimal(movingProductBlockWidth,2))
          const roundedRestSpace = Number(restSpace.toFixed(2));
          const roundedMovingProductBlockWidth = Number(movingProductBlockWidth.toFixed(2));
  
          props.setSpaceValidation(
            roundedRestSpace >= roundedMovingProductBlockWidth,
            roundOffDecimal(totalProductWidth,2),
            roundOffDecimal(totalShelfWidth,2),
            roundOffDecimal(restSpace,2),
            roundOffDecimal(movingProductBlockWidth,2),
            selectedShelfSet
          )
          ghostobj.selectedShelfSet = selectedShelfSet;
        }
      }
      props.updateGhostObjDetails(ghostobj);
  //     // console.log("MOVING END ------ previewShelves", previewShelves)
  //     // console.log("MOVING END ------ selectingField", selectingField)
  //     // console.log("MOVING END ------ previewprodlist", previewprodlist)
      props.setPreviewGuid(false, previewShelves, selectingField, false, previewprodlist);

    } else{
      props.setPreviewGuid(true);
    }

  }


  // This function returns the similar level shelves
  export function getSimilarLevelShelves(currentMovingSelectedShelf, mapFields) {
      // const result = [];
      // if(!currentMovingSelectedShelf) return result;
      // const currentFieldCustomId = currentMovingSelectedShelf.field_custom_id;
      // const currentY = currentMovingSelectedShelf.y;
      // const currentHeight = currentMovingSelectedShelf.drawHeight;
      // const currentX = currentMovingSelectedShelf.x;
      // const currentDrawWidth = currentMovingSelectedShelf.drawWidth;

      // for (const fieldId in mapFields) {
      //     // Skip the same field_custom_id
      //     if (fieldId === currentFieldCustomId) continue;

      //     const field = mapFields[fieldId];
      //     const shelves = field.shelf;

      //     for (const shelf of shelves) {
      //         const shelfY = shelf.y;
      //         const shelfHeight = shelf.drawHeight;

      //         // Check if the shelf is at a similar level
      //         if (roundOffDecimal(shelfY + shelfHeight, 2) === roundOffDecimal(currentY + currentHeight, 2)) {
      //         // if ((shelfY + shelfHeight > currentY && shelfY < currentY + currentHeight)) {
      //             result.push(shelf);
      //         }
      //     }
      // }

      // return result;

      // Version 2 - Added x nearest x coordination shelf picking changes
      //const currentFieldCustomId = currentMovingSelectedShelf.field_custom_id;
      const currentY = currentMovingSelectedShelf?.y;
      const currentHeight = currentMovingSelectedShelf?.drawHeight;
      const currentX = currentMovingSelectedShelf?.x;
      const currentDrawWidth = currentMovingSelectedShelf?.drawWidth;
      const currentShelf = currentMovingSelectedShelf?.rank;
  
      let shelvesAtSameLevel = [];

      // Collect shelves that are at the same Y level
      for (const fieldId in mapFields) {
          // if (fieldId === currentFieldCustomId) continue;
          //if(mapFields[fieldId].shelf === currentShelf) continue;
          
          const field = mapFields[fieldId];
          const shelves = field.shelf;

          for (const shelf of shelves) {
              
              const shelfY = shelf.y;
              const shelfHeight = shelf.drawHeight;

              // Check if the shelf is at the same level (y + height match)
              if (roundOffDecimal(shelfY + shelfHeight, 2) === roundOffDecimal(currentY + currentHeight, 2)) {
                  shelvesAtSameLevel.push(shelf);
              }
          }
      }

      // Sort shelves by x position
      shelvesAtSameLevel.sort((a, b) => a.x - b.x);

      // Find the selected shelf in the sorted list
      let selectedShelf = shelvesAtSameLevel.find(shelf => shelf.x === currentX && shelf.drawWidth === currentDrawWidth);
      if (!selectedShelf) {
          return [];
      }

      // Initialize merged shelves with the selected shelf
      let mergedShelves = [selectedShelf];

      // Check backward for connected shelves
      for (let i = shelvesAtSameLevel.indexOf(selectedShelf) - 1; i >= 0; i--) {
          if (shelvesAtSameLevel[i].x + shelvesAtSameLevel[i].drawWidth === mergedShelves[0].x) {
              mergedShelves.unshift(shelvesAtSameLevel[i]); // Add to the beginning
          } else {
              break;
          }
      }

      // Check forward for connected shelves
      for (let i = shelvesAtSameLevel.indexOf(selectedShelf) + 1; i < shelvesAtSameLevel.length; i++) {
          if (shelvesAtSameLevel[i].x === mergedShelves[mergedShelves.length - 1].x + mergedShelves[mergedShelves.length - 1].drawWidth) {
              mergedShelves.push(shelvesAtSameLevel[i]); // Add to the end
          } else {
              break;
          }
      }
      return mergedShelves;
  }

  // this function return the product list which is in the selected shelfs and similar level shelfs
  export function getSelectedProducts(existingProducts, selectedShelfSet, selectedProductBlock) {
    // Create a Set of IDs from selectedProductBlock for quick lookup
    const selectedProductIds = new Set(selectedProductBlock.map(product => product.id));
    
    // Filter products based on the conditions and exclude products in selectedProductBlock
    return existingProducts.filter(product => {
      const isInSelectedShelf = selectedShelfSet.some(shelf =>
          product?.shelfrank == shelf?.rank &&
          product?.field_custom_id == shelf?.field_custom_id &&
          (product?.isDelete === undefined || product?.isDelete === false) &&
          // remove hangged products
          (product?.isHanged === undefined || product?.isHanged === false)
      );

      const isNotInSelectedBlock = !selectedProductIds.has(product.id);

      return isInSelectedShelf && isNotInSelectedBlock;
    });
  }
  


  export function BlockContextMenu(props) {
    var xPos = props.xpos; //x position
    var yPos = props.ypos; //y position

    const popupRef = React.useRef(null);
    const [adjustedXPos, setAdjustedXPos] = React.useState(xPos);
    const [adjustedXposRTL, setAdjustedXposRTL] = React.useState(xPos);
    const [adjustedYPos, setAdjustedYPos] = React.useState(yPos);

    React.useEffect(() => {
      if (popupRef.current) {
        const popupRect = popupRef.current.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const parentRect = props.parentRef.current.getBoundingClientRect();
  
        if(props.isRTL === "rtl") {
          const newXPosRTL = Math.max(xPos, parentRect?.width - popupRect.width);
          //ensure it doesn't go off-screen on the right
          setAdjustedXposRTL(newXPosRTL < 0 ? 0 : newXPosRTL);
        }else{
          // Adjust x position to prevent overflow
          const newXPos = Math.min(xPos, parentRect?.width - popupRect.width);
          setAdjustedXPos(newXPos < 0 ? 0 : newXPos); // Ensure it doesn't go off-screen on the left 
        }
      }
    }, [xPos, yPos , props.isRTL, props.parentRef]);

    
    //handle click a button.  type: 1-delete,2-close,3-cut
    const handleClick = (type,event) => {
        if(type === 1){
            props.handleBlockDelete(false,true);
        } else if(type === 3){
          props.handleBlockCut();
        } else if(type === 5){
          props.handleBlockCut(true);
        } else
        {
            props.handlclose();
        }
    }
    
    return (<div className="rect-context-menu" onContextMenu={(e)=>{ e.preventDefault()}} style={{ top: yPos, left:  props.isRTL === "rtl" ? adjustedXposRTL : adjustedXPos }}>
              <ul className="text-center">
                  <li onClick={() => handleClick(1)}>{i18n.t("btnnames.delete")}</li><hr/>
                  <li onClick={() => handleClick(5)}>{i18n.t("COPY")}</li><hr/>
                  <li onClick={() => handleClick(3)}>{i18n.t("CUT")}</li><hr/>
                  <li onClick={() => handleClick(2)}>{i18n.t("btnnames.close")}</li>
              </ul>
            </div>
            );
  }
  
  export class NoSimProductsComp extends React.Component{
    constructor(props){
      super(props);

      this.state = {
        isListViewActive: "LIST",
        isdropdownopen:false,
      }
    }

    setisListViewActive = (ctype) =>{
      this.setState({ isListViewActive: ctype });
    }
    showWhyNotEligible=(prod)=>{
      //check reson not undifine
      var icon =<></>
      var nonsimreson=prod.notSimulatedReason
      // nonsimreson="none"
      if(nonsimreson){
        if(nonsimreson===notSimulatedReason.none){
          icon =<span title={this.props.t("NO_REASON")}><FeatherIcon color="red" icon="slash" size={14} /></span>
        }else
        if(nonsimreson===notSimulatedReason.heightIssue){
          icon =<span title={this.props.t("HEIGHT_NOT_ENOUGH")}><FeatherIcon color="red" icon="arrow-up-circle" size={14} /></span>
        }else
        if(nonsimreson===notSimulatedReason.minQtyIssue){
          icon =<span title={this.props.t("MIN_QTY")} style={{color:"red"}}>Qty</span>
        }
        else
        if(nonsimreson===notSimulatedReason.noEnoughSpace){
          icon =<span title={this.props.t("NOT_ENOGH_SPACE")} style={{color:"red"}}><CodeSquareIcon size={14} /></span>
        }else
        if(nonsimreson===notSimulatedReason.noTagMatching){
          icon =<span title={this.props.t("NO_TAG_MATCHING")}><FeatherIcon color="red" icon="tag" size={14} /></span>
        } else {
          const formattedReason = nonsimreson.replace(/_/g, ' ').replace(/^./, str => str.toUpperCase());
          icon=<span title={formattedReason}><FeatherIcon color="red" icon="alert-circle" size={14} /></span>
        }
      }
      

      return icon
    }
    onToggleHandler = (isOpen) => {
         this.setState({isdropdownopen:isOpen})
    }
    render(){
      // Generate filter lists from nonfilteredNonEProducts instead of using old API-fetched lists
      const nonfilteredProducts = this.props.nonfilteredNonEProducts || [];

      // Build category list from actual products
      const categoryMap = new Map();
      categoryMap.set(-1, {value: -1, label: this.props.t("NONE")});
      nonfilteredProducts.forEach(prod => {
        const catId = prod?.categoryId || prod?.category?.categoryId;
        const catName = prod?.categoryName || prod?.category?.categoryName;
        if (catId && catName && !categoryMap.has(catId)) {
          categoryMap.set(catId, {value: catId, label: catName});
        }
      });
      let filtercategoryList = Array.from(categoryMap.values());

      // Build subcategory list from actual products
      const subcategoryMap = new Map();
      subcategoryMap.set(-1, {value: -1, label: this.props.t("NONE")});
      nonfilteredProducts.forEach(prod => {
        const subCatId = prod?.subCat?.subCategoryid || prod?.subCategoryId;
        const subCatName = prod?.subCat?.subCategoryName || prod?.subCategoryName;
        if (subCatId && subCatName && !subcategoryMap.has(subCatId)) {
          subcategoryMap.set(subCatId, {value: subCatId, label: subCatName});
        }
      });
      let filterSubcategoryList = Array.from(subcategoryMap.values());

      // Build brand list from actual products
      const brandMap = new Map();
      brandMap.set(-1, {value: -1, label: this.props.t("NONE")});
      nonfilteredProducts.forEach(prod => {
        const brandId = prod?.brand?.brandid || prod?.brand?.brandId || prod?.brandId;
        const brandName = prod?.brand?.brandName || prod?.brandName;
        if (brandId && brandName && !brandMap.has(brandId)) {
          brandMap.set(brandId, {value: brandId, label: brandName});
        }
      });
      let filterBrnadList = Array.from(brandMap.values());

      // Build supplier list from actual products
      const supplierMap = new Map();
      supplierMap.set(-1, {value: -1, label: this.props.t("NONE")});
      nonfilteredProducts.forEach(prod => {
        const supplierId = prod?.supplier?.supplierId || prod?.supplierId;
        const supplierName = prod?.supplier?.supplierName || prod?.supplierName;
        if (supplierId && supplierName && !supplierMap.has(supplierId)) {
          supplierMap.set(supplierId, {value: supplierId, label: supplierName});
        }
      });
      let filterSupplierList = Array.from(supplierMap.values());
      const isFiltersApplied = this.props.selectedNonSimFilterCat.value>0 | this.props.selectedNonSimFiltersubCat.value>0 | this.props.selectedNonSimFilterBrand.value>0 | this.props.selectedNonSimFilterSupp.value>0
      return <Col>
        <div className={isFiltersApplied ? 'filter-tags' : ''}>
              {this.props.selectedNonSimFilterCat.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedNonSimFilterCat.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                  <span className='lable'>C: {this.props.selectedNonSimFilterCat.label}</span>
                  <span className='close' onClick={()=> this.props.togglenonSimFilter({value:-1, label:this.props.t("NONE")},"cat")}><XIcon size={15} /></span>
                </Col>
              </TooltipWrapper>:<></>}
              {this.props.selectedNonSimFiltersubCat.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedNonSimFiltersubCat.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>SC: {this.props.selectedNonSimFiltersubCat.label}</span>
                <span className='close' onClick={()=>this.props.togglenonSimFilter({value:-1, label:this.props.t("NONE")},"subcat")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
              {this.props.selectedNonSimFilterBrand.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedNonSimFilterBrand.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>B: {this.props.selectedNonSimFilterBrand.label}</span>
                <span className='close' onClick={()=>this.props.togglenonSimFilter({value:-1, label:this.props.t("NONE")},"brand")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
              {this.props.selectedNonSimFilterSupp.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedNonSimFilterSupp.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>S: {this.props.selectedNonSimFilterSupp.label}</span>
                <span className='close' onClick={()=>this.props.togglenonSimFilter({value:-1, label:this.props.t("NONE")},"supllier")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
        </div>
        <Col className='searchprodBox'>
        {/* <div>
          <div id="sim-options"/>
        </div> */}
          {(this.state.isListViewActive!==null&&this.props.nonfilteredNonEProducts&&this.props.nonfilteredNonEProducts.length>0&&(this.props.nonfilteredNonEProducts.filter(p=>p.isAdded!==true).length>0)?<>
            <div className='filter-sec'>
              <InputGroup size="sm" className="mb-3 input-search">
                  <InputGroup.Text id="inputGroup-sizing-sm"><SearchIcon size={18}/></InputGroup.Text>
                  <Form.Control id="filterprodtxt" aria-label="Small" value={this.props.noSim_filter} placeholder={this.props.t('srchproduct')} aria-describedby="inputGroup-sizing-sm" onChange={e => this.props.handleFilterNoEProducts(e.target.value)}/>
              </InputGroup>
              <Dropdown className='morefilterbtn nonfim-filter' show={this.state.isdropdownopen} onToggle={(isOpen, e, metadata) => this.onToggleHandler(isOpen, e, metadata)}>
                <Dropdown.Toggle variant="outline-primary" size='sm'>
                    <div className='Fbutton' ><FilterIconNew  dmode={this.props.dmode}/></div>
                    {(parseInt(this.props.selectedNonSimFilterCat.value)>0||parseInt(this.props.selectedNonSimFiltersubCat.value)>0||parseInt(this.props.selectedNonSimFilterBrand.value)>0||parseInt(this.props.selectedNonSimFilterSupp.value)>0)?
                    <div className='red-dot-more-filterscomman'></div>
                    :<></>}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Col className='prodlist-container nonsimfilter-container' style={{width: 358}}>
                    <Row>
                      <Col className="form-subcontent">
                          <label>{this.props.t('category')}</label>
                          <Select 
                              placeholder={this.props.t("category")} 
                              options={filtercategoryList} 
                              onChange={(e) => this.props.togglenonSimFilter(e,"cat")} 
                              value={filtercategoryList.filter(option => option.value === this.props.selectedNonSimFilterCat.value)} 
                              className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                              maxMenuHeight={200}    
                              />
                      </Col>
                      <Col className="form-subcontent">
                          <label>{this.props.t('subcategory')}</label>
                          <Select 
                          placeholder={this.props.t("subcategory")} 
                          options={filterSubcategoryList} 
                          onChange={(e) => this.props.togglenonSimFilter(e,"subcat")} 
                          value={filterSubcategoryList.filter(option => option.value === this.props.selectedNonSimFiltersubCat.value)} 
                          className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                          maxMenuHeight={200}    
                                      />
                      </Col>
                    </Row>
                    <Row>
                    <Col className="form-subcontent">
                      <label>{this.props.t('brand')}</label>
                          <Select 
                          placeholder={this.props.t("brand")} 
                          options={filterBrnadList} 
                          onChange={(e) =>  this.props.togglenonSimFilter(e,"brand")} 
                          value={filterBrnadList.filter(option => option.value ===this.props.selectedNonSimFilterBrand.value)} 
                          className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                          maxMenuHeight={200}    
                          />
                      </Col>
                      <Col className="form-subcontent">
                          <label>{this.props.t('suplable')}</label>
                          <Select 
                          placeholder={this.props.t("suplable")} 
                          options={filterSupplierList} 
                          onChange={(e) => this.props.togglenonSimFilter(e,"supllier")} 
                          value={filterSupplierList.filter(option => option.value === this.props.selectedNonSimFilterSupp.value)} 
                          className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                          maxMenuHeight={200}    
                                      />
                      </Col>
                    </Row>
                  </Col>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            
      
            <ButtonGroup style={{direction:"ltr"}} className={"pviewchange-list "+(this.props.isRTL=== "rtl"?"float-left":"float-right")}>
                {this.props.isRTL === "rtl" ? (
                    <>
                        <Button variant="secondary" onClick={() => this.setisListViewActive("GRID")} className={(this.state.isListViewActive==="GRID"?"active":"")}><DiffAddedIcon size={14}/></Button>
                        <Button variant="secondary" onClick={() => this.setisListViewActive("LIST")} className={(this.state.isListViewActive==="LIST"?"active":"")}><ListUnorderedIcon size={14} /></Button>
                    </>
                ) : (
                    <>
                        <Button variant="secondary" onClick={() => this.setisListViewActive("LIST")} className={(this.state.isListViewActive==="LIST"?"active":"")}><ListUnorderedIcon size={14} /></Button>
                        <Button variant="secondary" onClick={() => this.setisListViewActive("GRID")} className={(this.state.isListViewActive==="GRID"?"active":"")}><DiffAddedIcon size={14}/></Button>
                    </>
                )}
            </ButtonGroup>

              <Col className="col-xs-12 div-con">
                  <h5>{this.props.t('productslist')}
                  ({this.props.nonfilteredNonEProducts.filter(x=>x.isAdded!==true && x.isFilterd!==true && x.barcode && x.productName).length})
                  </h5>
                  <Col xs={12}  className="div-con subprod-list" style={{height: this.props.simType === 'AUI' ? isFiltersApplied ? this.props.catDivHeight - 120 : this.props.catDivHeight - 85 : isFiltersApplied ? this.props.catDivHeight + 120 : this.props.catDivHeight + 150}}>
                    <Row style={this.props.isRTL === "rtl"?{marginRight:"0px",width:"100%"}:{marginLeft:"0px",width:"100%"}}>
                      {/* {
                        // console.log(this.props.nonfilteredNonEProducts,"_________PRINT");
                      } */}
                        {(this.props.nonfilteredNonEProducts ? this.props.nonfilteredNonEProducts.map((prod, i) =>
                        {
                        const productShowLogic = (!prod.isAdded && !prod.isFilterd && prod.barcode && 'prod.productName || prod.name')
                        return  productShowLogic ?
                          <Col key={i} className={"sub-item"+(this.state.isListViewActive==="LIST"?"":" rectview")} xs={this.state.isListViewActive==="LIST"?12:4}><Col style={{ margin: 5}}>
                            {/* <span className={"editlink "+(prod.rotatetype&&(prod.rotatetype!=="default"&&prod.rotatetype!=="front"?"highred":""))} title={prod.rotatetype?(prod.rotatetype.replace("_"," ")):"default"} onClick={() => this.toggleRotateProd(prod,true)} style={(this.props.isRTL==="rtl"?{left:"35px"}:{right:"35px"})}><IssueReopenedIcon size={14}/></span>
                            <span className="editlink" onClick={() => this.handlePEMView(true,prod,false)}><ArrowSwitchIcon size={14}/></span> */}
                            <ProdRectView t={this.props.t} isRTL={this.props.isRTL} viewtype={this.state.isListViewActive} prod={prod}>
                                <div className="thumb-div" draggable id={prod.id} onClick={()=>this.props.handlePreviewModal(prod,true)} onMouseDown={(e) => {this.props.drawRectCanvas(prod)}} onDragStart={(e) => this.props.dragStart(e, prod)} onDrag={e => this.props.dragProdView(e, prod)} onDragEnd={() => this.props.prodDragEnd()}>
                                  <img key={i} src={prod?.imageUrl}
                                  style={{maxWidth: '100%', maxHeight: '100%', objectFit: 'contain'}}
                                   alt=""/>
                                </div>
                              </ProdRectView>
                              {(this.state.isListViewActive==="LIST"?
                                  <>
                                  <CopyToClipboard text={(prod.barcode?prod.barcode:"-")} onCopy={() => this.props.copyToClipboard()}><small style={{fontSize:"0.75rem"}}>{(prod.barcode?prod.barcode:"-")}</small></CopyToClipboard>
                                  <small className="nonesimReeson">{this.showWhyNotEligible(prod)}</small>
                                  {prod.isDimensionsChange?<small className="dimention-chnged"> <TooltipWrapper text={this.props.t("DIMENSION_CHNGES_NOT_AFFECTED")}><FeatherIcon icon="alert-triangle" size={16} /></TooltipWrapper></small>:<></>}
                                  <br/>
                                  <div style={{cursor:"pointer"}} onClick={()=>this.props.handleopenDetailmodal(prod)}>
                                  {(prod.productName?prod.productName:"-")}<br/>
                                  <small>{this.props.t("brand")+": "}{(prod.brandName && prod.brandName !== "" && prod.brandName !== "-")?(prod.brandName+" "):(this.props.t("notavailable")+" ")}</small><br/>
                                  <small style={{fontSize:"0.75rem"}}><i>
                                    {this.props.t('width')}: {(prod.width > 0?(roundOffDecimal(prod.width,numOfDecimalsLimit)+""+convertUomtoSym(prod.uom)):"0cm")}, 
                                    {this.props.t('height')}: {prod.height > 0?(roundOffDecimal(prod.height,numOfDecimalsLimit)+""+convertUomtoSym(prod.uom)):"0cm"}</i></small>
                                    </div>
                                  </>:
                              <></>)}
                          </Col></Col>
                          :<div key={i}></div>}
                          ):(<></>)
                        )}
                        {/* {this.state.srchprodsloading?<Col xs={12} className="text-center" style={{marginBottom: "5px"}}><img src={loadinggif} className="img-fluid" style={{height:"20px"}} alt="" /></Col>:<></>} */}
                    </Row>
                    {/* {props.filteredNonEProducts.length < this.state.ptotalresults?
                    <Col xs={12} className="ploadmore-link text-center" onClick={() => {this.loadMoreProds()}}>{this.props.t('btnnames.loadmore')}</Col>:<></>} */}
                  </Col>
                </Col>
              </>:
              <Col style={{paddingTop:"10px"}}><h4 className='text-center' style={{color: "#ccc", marginTop:"2rem"}}>{this.props.t("NO_PRODUCTS_AVAILABLE")}</h4></Col>)}
            </Col>
              
        </Col>;
    }
  }

  function ProdRectView(props) {
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const prod = props.prod;
    const isshowview = (props.viewtype === "LIST"?false:true);
    const trans = props.t;
    return (
      <>
        <div ref={target} onMouseOver={() => setShow(isshowview)} onMouseOut={() => setShow(false)}>
          {props.children}
        </div>
        <Overlay target={target.current} transition={false} show={show} 
        // placement={props.isRTL==="rtl"?"left":"right"}
        placement='top'
        >
          {(props) => (
            <Tooltip {...props}>
              <><small style={{fontSize:"0.75rem"}}>{prod.barcode&&prod.barcode}</small><br/>{(prod.brandName&&prod.brandName!==""&&prod.brandName!=="-"?(prod.brandName+" "):(i18n.t("notavailable")+" "))+prod.productName}<br/>
              <small style={{fontSize:"0.75rem"}}><i>{trans?trans('WIDTH'):"Width"} {prod.width+""+convertUomtoSym(prod.uom)}, {trans?trans('HEIGHT'):"Height"} {prod.height+""+convertUomtoSym(prod.uom)}</i></small></>
            </Tooltip>
          )}
        </Overlay>
      </>
    );
  }

  export function DimensionChangedProdComp (props){
    const [productEditWarningsList,setproductEditWarningsList] = useState([]);
    
    useEffect(() => { 
      setproductEditWarningsList(props.productEditWarningsList)
    }, [props.productEditWarningsList]);
    
    const handleFilterProducts = (evt) => { 
      let updList=structuredClone(props.productEditWarningsList)
      let newlist=[]
      let searchTxt = (evt.target.value && evt.target.value.length > 0?evt.target.value:"");
            for (let i = 0; i < updList.length; i++) {
                const nonladprod = updList[i];
                let nonSearchQuery = ((nonladprod.barcode?nonladprod.barcode.toLowerCase():"")+" "+(nonladprod.productName?nonladprod.productName.toLowerCase():""));
                let isnotfiltered=(nonSearchQuery.includes(searchTxt.toLowerCase())  );
                if(isnotfiltered){
                  newlist.push(nonladprod)
                }
            }
            setproductEditWarningsList(newlist)
    }
    return <Col >
      <Col className='searchprodBox'>                    
        {props.productEditWarningsList.length>0?<InputGroup size="sm" className="mb-3 input-search">
            <Form.Control id="filterprodtxt" aria-label="Small" placeholder={props.t('srchproduct')} aria-describedby="inputGroup-sizing-sm" onKeyUp={e => handleFilterProducts(e)}/>
            {/* <InputGroup.Prepend> */}
                <InputGroup.Text id="inputGroup-sizing-sm"><SearchIcon size={18}/></InputGroup.Text>
            {/* </InputGroup.Prepend> */}
        </InputGroup>:<></>}
        {(productEditWarningsList.length>0?<>
              <Col className="col-xs-12 div-con">
                  <h5>{props.t('productslist')} <span className='clearall-dim-prod' onClick={()=>props.handleacknowledgeSimulationWarning()}>{props.t("btnnames.clearall")}</span>
                  </h5>
                 
                  <Col xs={12}  className="div-con subprod-list" style={{height: props.simType === 'AUI' ? props.catDivHeight - 85 : props.catDivHeight + 150}}>
                    <Row style={props.isRTL === "rtl"?{marginRight:"0px",width:"100%"}:{marginLeft:"0px",width:"100%"}}>
                        {(productEditWarningsList ?productEditWarningsList.map((prod, i) =>
                        
                          { return  (!prod.isAdded && !prod.isFilterd && prod.barcode && prod.productName)?
                          <Col key={i} className="sub-item" xs={12}><Col style={{ margin: 5}}>
                            {/* <span className={"editlink "+(prod.rotatetype&&(prod.rotatetype!=="default"&&prod.rotatetype!=="front"?"highred":""))} title={prod.rotatetype?(prod.rotatetype.replace("_"," ")):"default"} onClick={() => this.toggleRotateProd(prod,true)} style={(this.props.isRTL==="rtl"?{left:"35px"}:{right:"35px"})}><IssueReopenedIcon size={14}/></span>
                            <span className="editlink" onClick={() => this.handlePEMView(true,prod,false)}><ArrowSwitchIcon size={14}/></span> */}
                            <ProdRectView t={props.t} isRTL={props.isRTL} viewtype={"LIST"} prod={prod}>
                                {/* onMouseDown={(e) => {props.drawRectCanvas(prod)}} onDragStart={(e) => props.dragStart(e, prod)} onDrag={e => props.dragProdView(e, prod)} onDragEnd={() => props.prodDragEnd()} */}
                                <div className="thumb-div" draggable id={prod.id} onClick={()=>props.handlePreviewModal(prod,true)}>
                                  <img key={i} src={prod.imageUrl} className={(prod.width >= prod.height)?"img-resize-ver":"img-resize-hor"} alt=""/>
                                </div>
                              </ProdRectView>
                                  <>
                                  <CopyToClipboard text={(prod.barcode?prod.barcode:"-")} onCopy={() => props.copyToClipboard()}><small style={{fontSize:"0.75rem"}}>{(prod.barcode?prod.barcode:"-")}</small></CopyToClipboard>
                                  <TooltipWrapper placement="bottom" text=  {props.t("REMOVE")}><small onClick={()=>props.handleacknowledgeSimulationWarning(prod)} className="nonesimReeson aknowladge"><FeatherIcon icon="delete" size={16} /></small></TooltipWrapper>
                                  <br/>
                                  <div style={{cursor:"pointer"}} onClick={()=>props.handleopenDetailmodal(prod)}>
                                    {(prod.productName?prod.productName:"-")}<br/>
                                    <small>{props.t("brand")+": "}{(prod.brandName && prod.brandName !== "" && prod.brandName !== "-")?(prod.brandName+" "):(props.t("notavailable")+" ")}</small><br/>
                                    <small style={{fontSize:"0.75rem"}}><i>{props.t('width')}: {(prod.width > 0?(prod.width+""+convertUomtoSym(prod.uom)):"0cm")}, {props.t('height')}: {prod.height > 0?(prod.height+""+convertUomtoSym(prod.uom)):"0cm"}</i></small>
                                  </div>
                                 </>
                             
                          </Col></Col>
                          :<div key={i}></div>}
                          ):(<></>)
                        )}
                        {/* {this.state.srchprodsloading?<Col xs={12} className="text-center" style={{marginBottom: "5px"}}><img src={loadinggif} className="img-fluid" style={{height:"20px"}} alt="" /></Col>:<></>} */}
                    </Row>
                    {/* {props.filteredNonEProducts.length < this.state.ptotalresults?
                    <Col xs={12} className="ploadmore-link text-center" onClick={() => {this.loadMoreProds()}}>{this.props.t('btnnames.loadmore')}</Col>:<></>} */}
                  </Col>
                </Col>
              </>:
              <Col style={{paddingTop:"10px"}}><h4 className='text-center' style={{color: "#ccc", marginTop:"2rem"}}>{props.t("NO_PRODUCTS_AVAILABLE")}</h4></Col>)}
        {/* <Col className="col-xs-12 div-con">
          <h5>{i18n.t('productslist')}</h5>
          <><CopyToClipboard text={(prod.barcode?prod.barcode:"-")} onCopy={() => this.props.copyToClipboard()}><small style={{fontSize:"0.75rem"}}>{(prod.barcode?prod.barcode:"-")}</small></CopyToClipboard>
                                  <small className="nonesimReeson">{this.showWhyNotEligible(prod)}</small>
                                  <br/>
                                  {(prod.productName?prod.productName:"-")}<br/>
                                  <small>{this.props.t("brand")+": "}{(prod.brandName && prod.brandName !== "" && prod.brandName !== "-")?(prod.brandName+" "):(this.props.t("notavailable")+" ")}</small><br/>
                                  <small style={{fontSize:"0.75rem"}}><i>{this.props.t('width')}: {(prod.width > 0?(prod.width+""+convertUomtoSym(prod.uom)):"0cm")}, {this.props.t('height')}: {prod.height > 0?(prod.height+""+convertUomtoSym(prod.uom)):"0cm"}</i></small></>
        </Col> */}
      </Col>
    </Col>
  }

  export class SaleCycleComp extends React.Component{
    constructor(props){
      super(props);

      this.state = {
        isdropdownopen:false,
      }
    }

    onToggleHandler = (isOpen) => {
         this.setState({isdropdownopen:isOpen})
    }
    
    render(){
      let filtercategoryList = JSON.parse(JSON.stringify(this.props.scFilter_categoryList));
      filtercategoryList[0] = {value:-1, label:this.props.t("Any")};
      let filterBrnadList = JSON.parse(JSON.stringify(this.props.scFilter_brandsList));
      filterBrnadList[0] = {value:-1, label:this.props.t("Any")};
      let filterSupplierList = JSON.parse(JSON.stringify(this.props.scFilter_supplierList));
      filterSupplierList[0] = {value:-1, label:this.props.t("Any")};
      let filterSubcategoryList = JSON.parse(JSON.stringify(this.props.scFilter_subcategoryList));
      filterSubcategoryList[0] = {value:-1, label:this.props.t("Any")};
      let filterStatusList = JSON.parse(JSON.stringify(this.props.scFilter_statusList));
      filterStatusList[0] = {value:-1, label:this.props.t("Any")};
      const isFiltersApplied = this.props.selectedScFilterCat.value>0 | this.props.selectedScFiltersubcat.value>0 | this.props.selectedScFilterBrand.value>0 | this.props.selectedScFilterSupp.value>0 | parseInt(this.props.selectedScFilterStat.value)!==-1
      return <Col>
        <Col className={isFiltersApplied ? 'filter-tags' : ''}>
              {this.props.selectedScFilterCat.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedScFilterCat.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                  <span className='lable'>C: {this.props.selectedScFilterCat.label}</span>
                  <span className='close' onClick={()=> this.props.toggleSCFilter({value:-1, label:this.props.t("NONE")},"cat")}><XIcon size={15} /></span>
                </Col>
              </TooltipWrapper>:<></>}
              {this.props.selectedScFiltersubcat.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedScFiltersubcat.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>SC: {this.props.selectedScFiltersubcat.label}</span>
                <span className='close' onClick={()=>this.props.toggleSCFilter({value:-1, label:this.props.t("NONE")},"subcat")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
              {this.props.selectedScFilterBrand.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedScFilterBrand.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>B: {this.props.selectedScFilterBrand.label}</span>
                <span className='close' onClick={()=>this.props.toggleSCFilter({value:-1, label:this.props.t("NONE")},"brand")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
              {this.props.selectedScFilterSupp.value>0?<TooltipWrapper placement="bottom" text=  {this.props.selectedScFilterSupp.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>S: {this.props.selectedScFilterSupp.label}</span>
                <span className='close' onClick={()=>this.props.toggleSCFilter({value:-1, label:this.props.t("NONE")},"supllier")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
              {parseInt(this.props.selectedScFilterStat.value)!==-1?<TooltipWrapper placement="bottom" text=  {this.props.selectedScFilterStat.label}>
                <Col className={"item" } style={{maxWidth: this.props.simType === 'AUI' ? 105 : 80}}>
                <span className='lable'>STS: {this.props.selectedScFilterStat.label}</span>
                <span className='close' onClick={()=>this.props.toggleSCFilter({value:-1, label:this.props.t("NONE")},"status")}><XIcon size={15} /></span>
                </Col> 
              </TooltipWrapper>:<></>}
        </Col>

        <Col className='searchprodBox'>
        
          <div className='filter-sec'>
            <InputGroup size="sm" className="mb-3 input-search">
                <Form.Control id="filterprodtxt" aria-label="Small" value={this.props.sc_filter} placeholder={this.props.t('srchproduct')} aria-describedby="inputGroup-sizing-sm" onChange={e => this.props.handleFilterSCProducts(e.target.value)}/>
                <InputGroup.Text id="inputGroup-sizing-sm"><SearchIcon size={18}/></InputGroup.Text>
            </InputGroup>
            <Dropdown className='morefilterbtn nonfim-filter' show={this.state.isdropdownopen} onToggle={(isOpen, e, metadata) => this.onToggleHandler(isOpen, e, metadata)}>
              <Dropdown.Toggle variant="outline-primary" size='sm'>
                  <div className='Fbutton'><FilterIconNew  dmode={this.props.dmode}/></div>
                  {(parseInt(this.props.selectedScFilterCat.value)>0||parseInt(this.props.selectedScFiltersubcat.value)>0||parseInt(this.props.selectedScFilterBrand.value)>0||parseInt(this.props.selectedScFilterSupp.value)>0||parseInt(this.props.selectedScFilterStat.value)>0)?
                  <div className='red-dot-more-filterscomman'></div>
                  :<></>}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Col className='prodlist-container nonsimfilter-container' style={{width: 338}}>
                  <Row>
                    <Col className="form-subcontent">
                        <label>{this.props.t('category')}</label>
                        <Select 
                            placeholder={this.props.t("category")} 
                            options={filtercategoryList} 
                            onChange={(e) => this.props.toggleSCFilter(e,"cat")} 
                            value={filtercategoryList.filter(option => option.value === this.props.selectedScFilterCat.value)} 
                            className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                            maxMenuHeight={200}    
                            />
                    </Col>
                    <Col className="form-subcontent">
                        <label>{this.props.t('subcategory')}</label>
                        <Select 
                        placeholder={this.props.t("subcategory")} 
                        options={filterSubcategoryList} 
                        onChange={(e) => this.props.toggleSCFilter(e,"subcat")} 
                        value={filterSubcategoryList.filter(option => option.value === this.props.selectedScFiltersubcat.value)} 
                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                        maxMenuHeight={200}    
                                    />
                    </Col>
                  </Row>
                  <Row>
                  <Col className="form-subcontent">
                    <label style={{margin: '11px 0'}}>{this.props.t('brand')}</label>
                        <Select 
                        placeholder={this.props.t("brand")} 
                        options={filterBrnadList} 
                        onChange={(e) =>  this.props.toggleSCFilter(e,"brand")} 
                        value={filterBrnadList.filter(option => option.value ===this.props.selectedScFilterBrand.value)} 
                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                        maxMenuHeight={200}    
                        />
                    </Col>
                    <Col className="form-subcontent">
                        <label style={{margin: '11px 0'}}>{this.props.t('suplable')}</label>
                        <Select 
                        placeholder={this.props.t("suplable")} 
                        options={filterSupplierList} 
                        onChange={(e) => this.props.toggleSCFilter(e,"supllier")} 
                        value={filterSupplierList.filter(option => option.value === this.props.selectedScFilterSupp.value)} 
                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                        maxMenuHeight={200}    
                                    />
                    </Col>
                    <Col className="form-subcontent">
                        <label>{this.props.t(`SALE_CYCLE`)+' '+this.props.t(`status`)}</label>
                        <Select 
                        placeholder={this.props.t(`status`)} 
                        options={filterStatusList} 
                        onChange={(e) => this.props.toggleSCFilter(e,"status")} 
                        value={filterStatusList.filter(option => option.value === this.props.selectedScFilterStat.value)} 
                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                        maxMenuHeight={200}    
                                    />
                    </Col>
                  </Row>
                </Col>
              </Dropdown.Menu>
            </Dropdown>
            <span className="sim-edit-info-icon">
              <PopoverWrapper cusid="sim-edit-pop" trigger={["hover","focus"]} 
                  text={
                      <div className='popover-cont'>
                            <h6>{this.props.t("SALE_CYCLE_LOGIC")}</h6>
                            <div className="formula">
                                <span className="image">
                                  <Image src={SalesCycleIcon}/>
                                </span>
                                <span className="word">
                                  {this.props.t("SALE_CYCLE")}
                                </span>
                                <span className="signs">
                                  =
                                </span>
                                <span className="image">
                                  <Image src={ThreeDQtyIcon}/>
                                </span>
                                <span className="word">
                                  {this.props.t('THREEDQTY')}
                                </span>
                                <span className="signs">
                                  {this.props.isRTL === "rtl" ?')/' : '/('}
                                </span>
                                <span className="image">
                                  <Image src={SaleQtyIcon}/>
                                </span>
                                <span className="word">
                                  {this.props.t('SALEQTY')}
                                </span>
                                <span className="signs">
                                  /
                                </span>
                                <span className="image">
                                  <Image src={DayCountIcon}/>
                                </span>
                                <span className="word">
                                  {this.props.t('DAYCOUNT')}
                                </span>
                                <span className="signs">
                                  {this.props.isRTL === "rtl" ? '(' : ')'}
                                </span>
                            </div>
                      </div>
                  } placement="top">
                  <FeatherIcon icon="info" size={20}/>
              </PopoverWrapper>
            </span>
          </div>
          { this.props.isChainSaleCycle ?
          <div className="chain-level-warn">
            <span className="chain-warn-icon">
                  <Image src={WarnIcon} />
            </span>
            <span className="chain-warn-text">
                  {this.props.t('CAL_CHAIN')} 
            </span>
          </div>
          :<></>}
            {(this.props.nonfilteredSCProducts&&this.props.nonfilteredSCProducts.length>0?
            <>
            <Col className="col-xs-12 div-con">
                <Col xs={12}  className="div-con subprod-list sale-cycle-list" style={{height: this.props.simType === 'AUI' ? isFiltersApplied ? this.props.catDivHeight - 120 : this.props.catDivHeight - 80 : isFiltersApplied ? this.props.catDivHeight + 120 : this.props.catDivHeight + 150}}>
                  <Row style={this.props.isRTL === "rtl"?{marginRight:"0px",width:"100%"}:{marginLeft:"0px",width:"100%"}}>
                      {(this.props.nonfilteredSCProducts ? this.props.nonfilteredSCProducts.map((prod, i) => {
                        return (// { return  (!prod.isAdded && !prod.isFilterd && prod.barcode && prod.productName)?
                        <Col key={i} style={{ border: this.props.selectedScProductId === prod.productId ? this.props.dmode ? "2px solid #2CC990" : "2px solid #5128A0" : "none", background: this.props.dmode ? "#374658" : "#F2F1FF"}} className={"sub-item"} xs={12}>
                          <Col style={{ margin: 5}}>
                                <>
                                  <div className={"color-strip-"+(prod.salesAvailable ? prod.anomaly==="no" ? "normal" : prod.anomaly==="high" ? "high" : "low"  :"none")}></div>

                                  <ProdRectView t={this.props.t} isRTL={this.props.isRTL} viewtype={"LIST"} prod={prod}>
                                    <div className="thumb-div-sc" id={prod.productId} onClick={()=>this.props.handlePreviewModal(prod,true)}>
                                      <img key={i} src={prod.imageUrl ? prod.imageUrl : DefaultProdImg} className={(prod.width >= prod.height)?"img-resize-ver":"img-resize-hor"} alt=""/>
                                    </div>
                                  </ProdRectView>
                                  <CopyToClipboard text={(prod.productBarcode?prod.productBarcode:"-")} onCopy={() => this.props.copyToClipboard()}><small style={{fontSize:"0.75rem"}}>{(prod.productBarcode?prod.productBarcode:"-")}</small></CopyToClipboard>
                                  <span className={"anomaly-value-"+(prod.salesAvailable ? prod.anomaly==="no" ? "normal" : prod.anomaly==="high" ? "high" : "low"  :"none")}>{prod.salesCycle ? prod.salesCycle.toFixed(2) : "-"}</span>
                                  <br/>
                                  <div className="sc-prod-name" style={{cursor:"pointer"}} onClick={()=>this.props.showSelectedSCProduct(prod.productId)}>
                                  {(prod.productName?prod.productName:"-")}<br/>
                                  </div>
                                  <div className="metrics">
                                          <span className="single-metric" title={this.props.t('THREEDQTY')}>
                                            <Image src={MiniThreeDQtyIcon}/>
                                            {prod.prodQty ? prod.prodQty : "-"}
                                          </span>

                                          <span className="single-metric" title={this.props.t('SALEQTY')}>
                                            <Image src={MiniSaleQtyIcon}/>
                                            {prod.salesAvailable ? prod.saleQty : "-"}
                                          </span>

                                          <span className="single-metric" title={this.props.t('DAYCOUNT')}>
                                            <Image src={MiniDayCountIcon}/>
                                            {prod.dayCount}
                                          </span>
                                  </div>
                                </>
                          </Col>
                        </Col>
                      )}
                        // :<div key={i}></div>}
                        ):(<></>)
                      )}
                  </Row>
                </Col>
              </Col>    
            </>:
            <Col style={{paddingTop:"10px"}}><h4 className='text-center' style={{color: "#ccc", marginTop:"2rem"}}>{this.props.t("NO_PRODUCTS_AVAILABLE")}</h4></Col>)}
      </Col>

      </Col>
    }
  }

  export function RuleWarningsComp (props){
    return(
      <Row>
        <Col xs={12} className='tab-content-view-v2' style={{height:props.simType === 'AUI' ? props.catDivHeight - 10 : props.catDivHeight + 200, marginTop: 10}}>
          <Col className='ruleswarn-content' >
      
      {props.isRuleWarn && props.isRuleWarn.totalcount > 0?<>
        <Row className='ruletitle-row'>
            <Col xs={8} className="title-col-v2">{props.trans("rules")}</Col>
            <Col xs={2} className="title-col-v2">{props.trans("RULE_PER")}</Col>
            <Col xs={2} className="title-col-v2">{props.trans("SIMULATED_PER")}</Col>
        </Row> 

        {props.mapRulesList.map((citem, cidx) => {
          return <React.Fragment key={cidx}>
            {citem.subCategoryRulePercentageDtos && citem.subCategoryRulePercentageDtos.length > 0?<><Row className="scroll-content">
              {citem.subCategoryRulePercentageDtos.map((subrule, sruledix) => {

                let ruleitemname = ((subrule.level === catRuleEnums.sup && subrule.supplier)?subrule.supplier.supplierName
                  :(subrule.level === catRuleEnums.brand && subrule.brand)?subrule.brand.brandName:"-")
                let mainbarcolor=subrule.ruleState === "danger"?"#bd132a":subrule.ruleState === "warning"?" #F39C12":subrule.ruleState === "default"?"#0eab3a":"none"
                return <React.Fragment key={sruledix}>
                  
                  <Col xs={12} className={'singlerulewarn-contain-v2'+(subrule.ruleState?(" "+subrule.ruleState):"")}>
                    <Row className='rulewarn-wrapper'>
                      <Col xs={8} style={{padding: "0px 5px"}}>
                      <CustomProgressBarForRules text={stringtrim(ruleitemname+" - "+(subrule.level?subrule.level.substring(0,3):""),30)} mainbarcolor={mainbarcolor} mainbarpercentage={subrule.simulatedPercentage} textcolor={"white"} showsubbar="true" subbarpercentage={subrule.rulePercentage} />
                        {/* <div className={'rulewarn-icon'+(subrule.ruleState?(" "+subrule.ruleState):"")}>
                          {subrule.ruleState === "danger"?<FeatherIcon icon="x-square" size={14} />:subrule.ruleState === "warning"?<FeatherIcon icon="alert-octagon" size={14} />:<FeatherIcon icon="check" size={14} />}
                        </div> */}

                        {/* <h6>{ruleitemname}<br/><small>{subrule.level}</small></h6> */}
                      </Col>
                      <Col xs={2} className='simper-wrapper'>
                        <Col className='simper-content-rule'><label style={{color: '#327DED',fontWeight: 'bold'}}>{subrule.rulePercentage}</label></Col>
                      </Col>
                      <Col xs={2} className='simper-wrapper'>
                        <Col className={'simper-content'+(subrule.ruleState?(" "+subrule.ruleState):"")}><label style={{textAlign: 'center'}}>{subrule.simulatedPercentage}</label></Col>  
                      </Col>
                    </Row>
                  </Col>
                </React.Fragment>;
              })}
            </Row></>:<></>}
          </React.Fragment>
        })}
      </>:
      <h5 className='text-center' style={{color: "#ccc", marginTop:"2rem"}}>{props.trans("NO_RULES_AVAILABLE")}</h5>}
          </Col>
        </Col>
      </Row>
      )
    }

  export function CustomProgressBarForRules(props) {
    return(
        <Col xs={12} className={"custom-progress-bar "+(props.isRTL)}>
            <Col className="name" style={{color:(props.subbarpercentage > 10 && props.textcolor?props.textcolor:"white"),textTransform:"uppercase"}}>{(props.text ? props.text:"")}</Col>
            <Col className="main-bar" style={{width:(props.mainbarpercentage+"%"), background:props.mainbarcolor}}></Col>
            {
                props.showsubbar==="true" || props.showsubbar === true ?
                <Col className="sub-bar" style={{width:(props.subbarpercentage+"%"),opacity:"0.5"}}></Col>
                :<></>
            }
            {
                props.showpercentage ?
                <span className='progress-txt'>{(props.mainbarpercentage+"%")}</span>
                :<></> 
            }
        </Col>
    )
  }

  export function ReplaceProductsTab (props){
    const [imgdropdown, setImgdropdown] = useState(null);
    const [contextMargin, setContextMargin] = useState(0);

    var prod={
      imageUrl:"https://d3ginyfiwc1r8i.cloudfront.net/main/8/7290017088693/854800_W100_100.png",height:12.5,width:32,
      barcode:8080808080,productName: "PRODUCT 197"
    }

    const handleMouseEnter = (evt, val) => {
      let elem = document.getElementById(val);
      let rect = elem.getBoundingClientRect();
      setContextMargin(rect.top);
      
      setImgdropdown(val);
    }

    const handleMouseLeave = () => {
      setImgdropdown(null);
    }
    var {replaceProds}=props
    return <Col className='replacedProd-content'>
      {replaceProds.length > 0?
      <>
       <div className='maindiv' style={{maxHeight:(props.catDivHeight+25)}}>
        {replaceProds.map((rprod,r) => {
          let tooltipid = props.viewSimID;

          return <Col key={r} className='card'>
              <Col style={{display:"flex",justifyContent:"space-between"}}>
                <div >
                  <div className="thumb-div" id={("prev"+r+""+tooltipid)} onMouseEnter={(e) => handleMouseEnter(e, ("prev"+r+""+tooltipid))} onMouseLeave={handleMouseLeave}> 
                    <img  src={rprod.currentProducts[0].imageUrl} className={(prod.width >= prod.height)?"img-resize-ver":"img-resize-hor"} alt=""/>
                    {rprod.replacedProducts.length>1&&<span className='MoreNo' 
                      // style={{left: "98px"}}
                      >{"+"+(rprod.currentProducts.length-1)}</span>}
                      {(imgdropdown===("prev"+r+""+tooltipid))&&
                      <div className="dropdown-content prev" style={{ top: (contextMargin+60)}}>
                      {rprod.currentProducts.length>0?rprod.currentProducts.map((prev,p)=> <div key={p} className='insideboxnameboxcard'>
                          <div className="thumb-div"  >
                            <img  src={prev.imageUrl} className={(prod.width >= prod.height)?"img-resize-ver":"img-resize-hor"} alt=""/>
                          </div>
                          <div className='text'><CopyToClipboard text={prev.barcode} onCopy={() => props.copyToClipboard()}><small style={{fontSize:"0.75rem"}}>{prev.barcode}</small></CopyToClipboard>
                          <h2 style={{fontSize:"0.75rem"}}>{prev.productName}</h2>
                          </div>
                        </div>):<></>}
                      </div>
                      }
                  </div>
                </div>
                <div style={{marginTop:"17px"}} className='arrow'><ReplaceProdIconArrow /></div>
                <div >
                  <div className="thumb-div" id={("now"+r+""+tooltipid)} onMouseEnter={(e) => handleMouseEnter(e, ("now"+r+""+tooltipid))} onMouseLeave={handleMouseLeave} >
                    <img  src={rprod.replacedProducts[0].imageUrl} className={(prod.width >= prod.height)?"img-resize-ver":"img-resize-hor"} alt=""/>
                    {rprod.replacedProducts.length>1&&<span className='MoreNo' 
                      // style={{left: "98px"}}
                      >{"+"+(rprod.replacedProducts.length-1)}</span>}
                      {(imgdropdown===("now"+r+""+tooltipid))&&
                      <div className="dropdown-content new" style={{ top: (contextMargin+60)}}>
                        {rprod.replacedProducts.length>0?rprod.replacedProducts.map((now,n)=> <div key={n} className='insideboxnameboxcard'>
                          <div className="thumb-div"  >
                            <img  src={now.imageUrl} className={(now.width >= now.height)?"img-resize-ver":"img-resize-hor"} alt=""/>
                          </div>
                          <div className='text'><CopyToClipboard text={now.barcode} onCopy={() => props.copyToClipboard()}><small style={{fontSize:"0.75rem"}}>{now.barcode}</small></CopyToClipboard>
                          <h2 style={{fontSize:"0.75rem"}}>{now.productName}</h2>
                          </div>
                        </div>):<></>}
                        
                      </div>
                      }
                  </div>
                </div>
              </Col>
            </Col>
          })}
       </div>
      </>
       :
      <h5 className='text-center' style={{color: "#ccc", marginTop:"2rem"}}>{props.trans("NO_REPLACED_PRODS_AVAILABLE")}</h5>} 
      </Col>;
    }

 